(function () {

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
// packages/alpinejs/src/scheduler.js
var $99b18dd98d1424fc$var$flushPending = false;
var $99b18dd98d1424fc$var$flushing = false;
var $99b18dd98d1424fc$var$queue = [];
var $99b18dd98d1424fc$var$lastFlushedIndex = -1;
function $99b18dd98d1424fc$var$scheduler(callback) {
    $99b18dd98d1424fc$var$queueJob(callback);
}
function $99b18dd98d1424fc$var$queueJob(job) {
    if (!$99b18dd98d1424fc$var$queue.includes(job)) $99b18dd98d1424fc$var$queue.push(job);
    $99b18dd98d1424fc$var$queueFlush();
}
function $99b18dd98d1424fc$var$dequeueJob(job) {
    let index = $99b18dd98d1424fc$var$queue.indexOf(job);
    if (index !== -1 && index > $99b18dd98d1424fc$var$lastFlushedIndex) $99b18dd98d1424fc$var$queue.splice(index, 1);
}
function $99b18dd98d1424fc$var$queueFlush() {
    if (!$99b18dd98d1424fc$var$flushing && !$99b18dd98d1424fc$var$flushPending) {
        $99b18dd98d1424fc$var$flushPending = true;
        queueMicrotask($99b18dd98d1424fc$var$flushJobs);
    }
}
function $99b18dd98d1424fc$var$flushJobs() {
    $99b18dd98d1424fc$var$flushPending = false;
    $99b18dd98d1424fc$var$flushing = true;
    for(let i = 0; i < $99b18dd98d1424fc$var$queue.length; i++){
        $99b18dd98d1424fc$var$queue[i]();
        $99b18dd98d1424fc$var$lastFlushedIndex = i;
    }
    $99b18dd98d1424fc$var$queue.length = 0;
    $99b18dd98d1424fc$var$lastFlushedIndex = -1;
    $99b18dd98d1424fc$var$flushing = false;
}
// packages/alpinejs/src/reactivity.js
var $99b18dd98d1424fc$var$reactive;
var $99b18dd98d1424fc$var$effect;
var $99b18dd98d1424fc$var$release;
var $99b18dd98d1424fc$var$raw;
var $99b18dd98d1424fc$var$shouldSchedule = true;
function $99b18dd98d1424fc$var$disableEffectScheduling(callback) {
    $99b18dd98d1424fc$var$shouldSchedule = false;
    callback();
    $99b18dd98d1424fc$var$shouldSchedule = true;
}
function $99b18dd98d1424fc$var$setReactivityEngine(engine) {
    $99b18dd98d1424fc$var$reactive = engine.reactive;
    $99b18dd98d1424fc$var$release = engine.release;
    $99b18dd98d1424fc$var$effect = (callback)=>engine.effect(callback, {
            scheduler: (task)=>{
                if ($99b18dd98d1424fc$var$shouldSchedule) $99b18dd98d1424fc$var$scheduler(task);
                else task();
            }
        });
    $99b18dd98d1424fc$var$raw = engine.raw;
}
function $99b18dd98d1424fc$var$overrideEffect(override) {
    $99b18dd98d1424fc$var$effect = override;
}
function $99b18dd98d1424fc$var$elementBoundEffect(el) {
    let cleanup2 = ()=>{};
    let wrappedEffect = (callback)=>{
        let effectReference = $99b18dd98d1424fc$var$effect(callback);
        if (!el._x_effects) {
            el._x_effects = /* @__PURE__ */ new Set();
            el._x_runEffects = ()=>{
                el._x_effects.forEach((i)=>i());
            };
        }
        el._x_effects.add(effectReference);
        cleanup2 = ()=>{
            if (effectReference === void 0) return;
            el._x_effects.delete(effectReference);
            $99b18dd98d1424fc$var$release(effectReference);
        };
        return effectReference;
    };
    return [
        wrappedEffect,
        ()=>{
            cleanup2();
        }
    ];
}
function $99b18dd98d1424fc$var$watch(getter, callback) {
    let firstTime = true;
    let oldValue;
    let effectReference = $99b18dd98d1424fc$var$effect(()=>{
        let value = getter();
        JSON.stringify(value);
        if (!firstTime) queueMicrotask(()=>{
            callback(value, oldValue);
            oldValue = value;
        });
        else oldValue = value;
        firstTime = false;
    });
    return ()=>$99b18dd98d1424fc$var$release(effectReference);
}
// packages/alpinejs/src/mutation.js
var $99b18dd98d1424fc$var$onAttributeAddeds = [];
var $99b18dd98d1424fc$var$onElRemoveds = [];
var $99b18dd98d1424fc$var$onElAddeds = [];
function $99b18dd98d1424fc$var$onElAdded(callback) {
    $99b18dd98d1424fc$var$onElAddeds.push(callback);
}
function $99b18dd98d1424fc$var$onElRemoved(el, callback) {
    if (typeof callback === "function") {
        if (!el._x_cleanups) el._x_cleanups = [];
        el._x_cleanups.push(callback);
    } else {
        callback = el;
        $99b18dd98d1424fc$var$onElRemoveds.push(callback);
    }
}
function $99b18dd98d1424fc$var$onAttributesAdded(callback) {
    $99b18dd98d1424fc$var$onAttributeAddeds.push(callback);
}
function $99b18dd98d1424fc$var$onAttributeRemoved(el, name, callback) {
    if (!el._x_attributeCleanups) el._x_attributeCleanups = {};
    if (!el._x_attributeCleanups[name]) el._x_attributeCleanups[name] = [];
    el._x_attributeCleanups[name].push(callback);
}
function $99b18dd98d1424fc$var$cleanupAttributes(el, names) {
    if (!el._x_attributeCleanups) return;
    Object.entries(el._x_attributeCleanups).forEach(([name, value])=>{
        if (names === void 0 || names.includes(name)) {
            value.forEach((i)=>i());
            delete el._x_attributeCleanups[name];
        }
    });
}
function $99b18dd98d1424fc$var$cleanupElement(el) {
    el._x_effects?.forEach($99b18dd98d1424fc$var$dequeueJob);
    while(el._x_cleanups?.length)el._x_cleanups.pop()();
}
var $99b18dd98d1424fc$var$observer = new MutationObserver($99b18dd98d1424fc$var$onMutate);
var $99b18dd98d1424fc$var$currentlyObserving = false;
function $99b18dd98d1424fc$var$startObservingMutations() {
    $99b18dd98d1424fc$var$observer.observe(document, {
        subtree: true,
        childList: true,
        attributes: true,
        attributeOldValue: true
    });
    $99b18dd98d1424fc$var$currentlyObserving = true;
}
function $99b18dd98d1424fc$var$stopObservingMutations() {
    $99b18dd98d1424fc$var$flushObserver();
    $99b18dd98d1424fc$var$observer.disconnect();
    $99b18dd98d1424fc$var$currentlyObserving = false;
}
var $99b18dd98d1424fc$var$queuedMutations = [];
function $99b18dd98d1424fc$var$flushObserver() {
    let records = $99b18dd98d1424fc$var$observer.takeRecords();
    $99b18dd98d1424fc$var$queuedMutations.push(()=>records.length > 0 && $99b18dd98d1424fc$var$onMutate(records));
    let queueLengthWhenTriggered = $99b18dd98d1424fc$var$queuedMutations.length;
    queueMicrotask(()=>{
        if ($99b18dd98d1424fc$var$queuedMutations.length === queueLengthWhenTriggered) while($99b18dd98d1424fc$var$queuedMutations.length > 0)$99b18dd98d1424fc$var$queuedMutations.shift()();
    });
}
function $99b18dd98d1424fc$var$mutateDom(callback) {
    if (!$99b18dd98d1424fc$var$currentlyObserving) return callback();
    $99b18dd98d1424fc$var$stopObservingMutations();
    let result = callback();
    $99b18dd98d1424fc$var$startObservingMutations();
    return result;
}
var $99b18dd98d1424fc$var$isCollecting = false;
var $99b18dd98d1424fc$var$deferredMutations = [];
function $99b18dd98d1424fc$var$deferMutations() {
    $99b18dd98d1424fc$var$isCollecting = true;
}
function $99b18dd98d1424fc$var$flushAndStopDeferringMutations() {
    $99b18dd98d1424fc$var$isCollecting = false;
    $99b18dd98d1424fc$var$onMutate($99b18dd98d1424fc$var$deferredMutations);
    $99b18dd98d1424fc$var$deferredMutations = [];
}
function $99b18dd98d1424fc$var$onMutate(mutations) {
    if ($99b18dd98d1424fc$var$isCollecting) {
        $99b18dd98d1424fc$var$deferredMutations = $99b18dd98d1424fc$var$deferredMutations.concat(mutations);
        return;
    }
    let addedNodes = [];
    let removedNodes = /* @__PURE__ */ new Set();
    let addedAttributes = /* @__PURE__ */ new Map();
    let removedAttributes = /* @__PURE__ */ new Map();
    for(let i = 0; i < mutations.length; i++){
        if (mutations[i].target._x_ignoreMutationObserver) continue;
        if (mutations[i].type === "childList") {
            mutations[i].removedNodes.forEach((node)=>{
                if (node.nodeType !== 1) return;
                if (!node._x_marker) return;
                removedNodes.add(node);
            });
            mutations[i].addedNodes.forEach((node)=>{
                if (node.nodeType !== 1) return;
                if (removedNodes.has(node)) {
                    removedNodes.delete(node);
                    return;
                }
                if (node._x_marker) return;
                addedNodes.push(node);
            });
        }
        if (mutations[i].type === "attributes") {
            let el = mutations[i].target;
            let name = mutations[i].attributeName;
            let oldValue = mutations[i].oldValue;
            let add2 = ()=>{
                if (!addedAttributes.has(el)) addedAttributes.set(el, []);
                addedAttributes.get(el).push({
                    name: name,
                    value: el.getAttribute(name)
                });
            };
            let remove = ()=>{
                if (!removedAttributes.has(el)) removedAttributes.set(el, []);
                removedAttributes.get(el).push(name);
            };
            if (el.hasAttribute(name) && oldValue === null) add2();
            else if (el.hasAttribute(name)) {
                remove();
                add2();
            } else remove();
        }
    }
    removedAttributes.forEach((attrs, el)=>{
        $99b18dd98d1424fc$var$cleanupAttributes(el, attrs);
    });
    addedAttributes.forEach((attrs, el)=>{
        $99b18dd98d1424fc$var$onAttributeAddeds.forEach((i)=>i(el, attrs));
    });
    for (let node of removedNodes){
        if (addedNodes.some((i)=>i.contains(node))) continue;
        $99b18dd98d1424fc$var$onElRemoveds.forEach((i)=>i(node));
    }
    for (let node of addedNodes){
        if (!node.isConnected) continue;
        $99b18dd98d1424fc$var$onElAddeds.forEach((i)=>i(node));
    }
    addedNodes = null;
    removedNodes = null;
    addedAttributes = null;
    removedAttributes = null;
}
// packages/alpinejs/src/scope.js
function $99b18dd98d1424fc$var$scope(node) {
    return $99b18dd98d1424fc$var$mergeProxies($99b18dd98d1424fc$var$closestDataStack(node));
}
function $99b18dd98d1424fc$var$addScopeToNode(node, data2, referenceNode) {
    node._x_dataStack = [
        data2,
        ...$99b18dd98d1424fc$var$closestDataStack(referenceNode || node)
    ];
    return ()=>{
        node._x_dataStack = node._x_dataStack.filter((i)=>i !== data2);
    };
}
function $99b18dd98d1424fc$var$closestDataStack(node) {
    if (node._x_dataStack) return node._x_dataStack;
    if (typeof ShadowRoot === "function" && node instanceof ShadowRoot) return $99b18dd98d1424fc$var$closestDataStack(node.host);
    if (!node.parentNode) return [];
    return $99b18dd98d1424fc$var$closestDataStack(node.parentNode);
}
function $99b18dd98d1424fc$var$mergeProxies(objects) {
    return new Proxy({
        objects: objects
    }, $99b18dd98d1424fc$var$mergeProxyTrap);
}
var $99b18dd98d1424fc$var$mergeProxyTrap = {
    ownKeys ({ objects: objects }) {
        return Array.from(new Set(objects.flatMap((i)=>Object.keys(i))));
    },
    has ({ objects: objects }, name) {
        if (name == Symbol.unscopables) return false;
        return objects.some((obj)=>Object.prototype.hasOwnProperty.call(obj, name) || Reflect.has(obj, name));
    },
    get ({ objects: objects }, name, thisProxy) {
        if (name == "toJSON") return $99b18dd98d1424fc$var$collapseProxies;
        return Reflect.get(objects.find((obj)=>Reflect.has(obj, name)) || {}, name, thisProxy);
    },
    set ({ objects: objects }, name, value, thisProxy) {
        const target = objects.find((obj)=>Object.prototype.hasOwnProperty.call(obj, name)) || objects[objects.length - 1];
        const descriptor = Object.getOwnPropertyDescriptor(target, name);
        if (descriptor?.set && descriptor?.get) return descriptor.set.call(thisProxy, value) || true;
        return Reflect.set(target, name, value);
    }
};
function $99b18dd98d1424fc$var$collapseProxies() {
    let keys = Reflect.ownKeys(this);
    return keys.reduce((acc, key)=>{
        acc[key] = Reflect.get(this, key);
        return acc;
    }, {});
}
// packages/alpinejs/src/interceptor.js
function $99b18dd98d1424fc$var$initInterceptors(data2) {
    let isObject2 = (val)=>typeof val === "object" && !Array.isArray(val) && val !== null;
    let recurse = (obj, basePath = "")=>{
        Object.entries(Object.getOwnPropertyDescriptors(obj)).forEach(([key, { value: value, enumerable: enumerable }])=>{
            if (enumerable === false || value === void 0) return;
            if (typeof value === "object" && value !== null && value.__v_skip) return;
            let path = basePath === "" ? key : `${basePath}.${key}`;
            if (typeof value === "object" && value !== null && value._x_interceptor) obj[key] = value.initialize(data2, path, key);
            else if (isObject2(value) && value !== obj && !(value instanceof Element)) recurse(value, path);
        });
    };
    return recurse(data2);
}
function $99b18dd98d1424fc$var$interceptor(callback, mutateObj = ()=>{}) {
    let obj = {
        initialValue: void 0,
        _x_interceptor: true,
        initialize (data2, path, key) {
            return callback(this.initialValue, ()=>$99b18dd98d1424fc$var$get(data2, path), (value)=>$99b18dd98d1424fc$var$set(data2, path, value), path, key);
        }
    };
    mutateObj(obj);
    return (initialValue)=>{
        if (typeof initialValue === "object" && initialValue !== null && initialValue._x_interceptor) {
            let initialize = obj.initialize.bind(obj);
            obj.initialize = (data2, path, key)=>{
                let innerValue = initialValue.initialize(data2, path, key);
                obj.initialValue = innerValue;
                return initialize(data2, path, key);
            };
        } else obj.initialValue = initialValue;
        return obj;
    };
}
function $99b18dd98d1424fc$var$get(obj, path) {
    return path.split(".").reduce((carry, segment)=>carry[segment], obj);
}
function $99b18dd98d1424fc$var$set(obj, path, value) {
    if (typeof path === "string") path = path.split(".");
    if (path.length === 1) obj[path[0]] = value;
    else if (path.length === 0) throw error;
    else {
        if (obj[path[0]]) return $99b18dd98d1424fc$var$set(obj[path[0]], path.slice(1), value);
        else {
            obj[path[0]] = {};
            return $99b18dd98d1424fc$var$set(obj[path[0]], path.slice(1), value);
        }
    }
}
// packages/alpinejs/src/magics.js
var $99b18dd98d1424fc$var$magics = {};
function $99b18dd98d1424fc$var$magic(name, callback) {
    $99b18dd98d1424fc$var$magics[name] = callback;
}
function $99b18dd98d1424fc$var$injectMagics(obj, el) {
    let memoizedUtilities = $99b18dd98d1424fc$var$getUtilities(el);
    Object.entries($99b18dd98d1424fc$var$magics).forEach(([name, callback])=>{
        Object.defineProperty(obj, `$${name}`, {
            get () {
                return callback(el, memoizedUtilities);
            },
            enumerable: false
        });
    });
    return obj;
}
function $99b18dd98d1424fc$var$getUtilities(el) {
    let [utilities, cleanup2] = $99b18dd98d1424fc$var$getElementBoundUtilities(el);
    let utils = {
        interceptor: $99b18dd98d1424fc$var$interceptor,
        ...utilities
    };
    $99b18dd98d1424fc$var$onElRemoved(el, cleanup2);
    return utils;
}
// packages/alpinejs/src/utils/error.js
function $99b18dd98d1424fc$var$tryCatch(el, expression, callback, ...args) {
    try {
        return callback(...args);
    } catch (e) {
        $99b18dd98d1424fc$var$handleError(e, el, expression);
    }
}
function $99b18dd98d1424fc$var$handleError(error2, el, expression) {
    error2 = Object.assign(error2 ?? {
        message: "No error message given."
    }, {
        el: el,
        expression: expression
    });
    console.warn(`Alpine Expression Error: ${error2.message}

${expression ? 'Expression: "' + expression + '"\n\n' : ""}`, el);
    setTimeout(()=>{
        throw error2;
    }, 0);
}
// packages/alpinejs/src/evaluator.js
var $99b18dd98d1424fc$var$shouldAutoEvaluateFunctions = true;
function $99b18dd98d1424fc$var$dontAutoEvaluateFunctions(callback) {
    let cache = $99b18dd98d1424fc$var$shouldAutoEvaluateFunctions;
    $99b18dd98d1424fc$var$shouldAutoEvaluateFunctions = false;
    let result = callback();
    $99b18dd98d1424fc$var$shouldAutoEvaluateFunctions = cache;
    return result;
}
function $99b18dd98d1424fc$var$evaluate(el, expression, extras = {}) {
    let result;
    $99b18dd98d1424fc$var$evaluateLater(el, expression)((value)=>result = value, extras);
    return result;
}
function $99b18dd98d1424fc$var$evaluateLater(...args) {
    return $99b18dd98d1424fc$var$theEvaluatorFunction(...args);
}
var $99b18dd98d1424fc$var$theEvaluatorFunction = $99b18dd98d1424fc$var$normalEvaluator;
function $99b18dd98d1424fc$var$setEvaluator(newEvaluator) {
    $99b18dd98d1424fc$var$theEvaluatorFunction = newEvaluator;
}
function $99b18dd98d1424fc$var$normalEvaluator(el, expression) {
    let overriddenMagics = {};
    $99b18dd98d1424fc$var$injectMagics(overriddenMagics, el);
    let dataStack = [
        overriddenMagics,
        ...$99b18dd98d1424fc$var$closestDataStack(el)
    ];
    let evaluator = typeof expression === "function" ? $99b18dd98d1424fc$var$generateEvaluatorFromFunction(dataStack, expression) : $99b18dd98d1424fc$var$generateEvaluatorFromString(dataStack, expression, el);
    return $99b18dd98d1424fc$var$tryCatch.bind(null, el, expression, evaluator);
}
function $99b18dd98d1424fc$var$generateEvaluatorFromFunction(dataStack, func) {
    return (receiver = ()=>{}, { scope: scope2 = {}, params: params = [] } = {})=>{
        let result = func.apply($99b18dd98d1424fc$var$mergeProxies([
            scope2,
            ...dataStack
        ]), params);
        $99b18dd98d1424fc$var$runIfTypeOfFunction(receiver, result);
    };
}
var $99b18dd98d1424fc$var$evaluatorMemo = {};
function $99b18dd98d1424fc$var$generateFunctionFromString(expression, el) {
    if ($99b18dd98d1424fc$var$evaluatorMemo[expression]) return $99b18dd98d1424fc$var$evaluatorMemo[expression];
    let AsyncFunction = Object.getPrototypeOf(async function() {}).constructor;
    let rightSideSafeExpression = /^[\n\s]*if.*\(.*\)/.test(expression.trim()) || /^(let|const)\s/.test(expression.trim()) ? `(async()=>{ ${expression} })()` : expression;
    const safeAsyncFunction = ()=>{
        try {
            let func2 = new AsyncFunction([
                "__self",
                "scope"
            ], `with (scope) { __self.result = ${rightSideSafeExpression} }; __self.finished = true; return __self.result;`);
            Object.defineProperty(func2, "name", {
                value: `[Alpine] ${expression}`
            });
            return func2;
        } catch (error2) {
            $99b18dd98d1424fc$var$handleError(error2, el, expression);
            return Promise.resolve();
        }
    };
    let func = safeAsyncFunction();
    $99b18dd98d1424fc$var$evaluatorMemo[expression] = func;
    return func;
}
function $99b18dd98d1424fc$var$generateEvaluatorFromString(dataStack, expression, el) {
    let func = $99b18dd98d1424fc$var$generateFunctionFromString(expression, el);
    return (receiver = ()=>{}, { scope: scope2 = {}, params: params = [] } = {})=>{
        func.result = void 0;
        func.finished = false;
        let completeScope = $99b18dd98d1424fc$var$mergeProxies([
            scope2,
            ...dataStack
        ]);
        if (typeof func === "function") {
            let promise = func(func, completeScope).catch((error2)=>$99b18dd98d1424fc$var$handleError(error2, el, expression));
            if (func.finished) {
                $99b18dd98d1424fc$var$runIfTypeOfFunction(receiver, func.result, completeScope, params, el);
                func.result = void 0;
            } else promise.then((result)=>{
                $99b18dd98d1424fc$var$runIfTypeOfFunction(receiver, result, completeScope, params, el);
            }).catch((error2)=>$99b18dd98d1424fc$var$handleError(error2, el, expression)).finally(()=>func.result = void 0);
        }
    };
}
function $99b18dd98d1424fc$var$runIfTypeOfFunction(receiver, value, scope2, params, el) {
    if ($99b18dd98d1424fc$var$shouldAutoEvaluateFunctions && typeof value === "function") {
        let result = value.apply(scope2, params);
        if (result instanceof Promise) result.then((i)=>$99b18dd98d1424fc$var$runIfTypeOfFunction(receiver, i, scope2, params)).catch((error2)=>$99b18dd98d1424fc$var$handleError(error2, el, value));
        else receiver(result);
    } else if (typeof value === "object" && value instanceof Promise) value.then((i)=>receiver(i));
    else receiver(value);
}
// packages/alpinejs/src/directives.js
var $99b18dd98d1424fc$var$prefixAsString = "x-";
function $99b18dd98d1424fc$var$prefix(subject = "") {
    return $99b18dd98d1424fc$var$prefixAsString + subject;
}
function $99b18dd98d1424fc$var$setPrefix(newPrefix) {
    $99b18dd98d1424fc$var$prefixAsString = newPrefix;
}
var $99b18dd98d1424fc$var$directiveHandlers = {};
function $99b18dd98d1424fc$var$directive(name, callback) {
    $99b18dd98d1424fc$var$directiveHandlers[name] = callback;
    return {
        before (directive2) {
            if (!$99b18dd98d1424fc$var$directiveHandlers[directive2]) {
                console.warn(String.raw`Cannot find directive \`${directive2}\`. \`${name}\` will use the default order of execution`);
                return;
            }
            const pos = $99b18dd98d1424fc$var$directiveOrder.indexOf(directive2);
            $99b18dd98d1424fc$var$directiveOrder.splice(pos >= 0 ? pos : $99b18dd98d1424fc$var$directiveOrder.indexOf("DEFAULT"), 0, name);
        }
    };
}
function $99b18dd98d1424fc$var$directiveExists(name) {
    return Object.keys($99b18dd98d1424fc$var$directiveHandlers).includes(name);
}
function $99b18dd98d1424fc$var$directives(el, attributes, originalAttributeOverride) {
    attributes = Array.from(attributes);
    if (el._x_virtualDirectives) {
        let vAttributes = Object.entries(el._x_virtualDirectives).map(([name, value])=>({
                name: name,
                value: value
            }));
        let staticAttributes = $99b18dd98d1424fc$var$attributesOnly(vAttributes);
        vAttributes = vAttributes.map((attribute)=>{
            if (staticAttributes.find((attr)=>attr.name === attribute.name)) return {
                name: `x-bind:${attribute.name}`,
                value: `"${attribute.value}"`
            };
            return attribute;
        });
        attributes = attributes.concat(vAttributes);
    }
    let transformedAttributeMap = {};
    let directives2 = attributes.map($99b18dd98d1424fc$var$toTransformedAttributes((newName, oldName)=>transformedAttributeMap[newName] = oldName)).filter($99b18dd98d1424fc$var$outNonAlpineAttributes).map($99b18dd98d1424fc$var$toParsedDirectives(transformedAttributeMap, originalAttributeOverride)).sort($99b18dd98d1424fc$var$byPriority);
    return directives2.map((directive2)=>{
        return $99b18dd98d1424fc$var$getDirectiveHandler(el, directive2);
    });
}
function $99b18dd98d1424fc$var$attributesOnly(attributes) {
    return Array.from(attributes).map($99b18dd98d1424fc$var$toTransformedAttributes()).filter((attr)=>!$99b18dd98d1424fc$var$outNonAlpineAttributes(attr));
}
var $99b18dd98d1424fc$var$isDeferringHandlers = false;
var $99b18dd98d1424fc$var$directiveHandlerStacks = /* @__PURE__ */ new Map();
var $99b18dd98d1424fc$var$currentHandlerStackKey = Symbol();
function $99b18dd98d1424fc$var$deferHandlingDirectives(callback) {
    $99b18dd98d1424fc$var$isDeferringHandlers = true;
    let key = Symbol();
    $99b18dd98d1424fc$var$currentHandlerStackKey = key;
    $99b18dd98d1424fc$var$directiveHandlerStacks.set(key, []);
    let flushHandlers = ()=>{
        while($99b18dd98d1424fc$var$directiveHandlerStacks.get(key).length)$99b18dd98d1424fc$var$directiveHandlerStacks.get(key).shift()();
        $99b18dd98d1424fc$var$directiveHandlerStacks.delete(key);
    };
    let stopDeferring = ()=>{
        $99b18dd98d1424fc$var$isDeferringHandlers = false;
        flushHandlers();
    };
    callback(flushHandlers);
    stopDeferring();
}
function $99b18dd98d1424fc$var$getElementBoundUtilities(el) {
    let cleanups = [];
    let cleanup2 = (callback)=>cleanups.push(callback);
    let [effect3, cleanupEffect] = $99b18dd98d1424fc$var$elementBoundEffect(el);
    cleanups.push(cleanupEffect);
    let utilities = {
        Alpine: $99b18dd98d1424fc$var$alpine_default,
        effect: effect3,
        cleanup: cleanup2,
        evaluateLater: $99b18dd98d1424fc$var$evaluateLater.bind($99b18dd98d1424fc$var$evaluateLater, el),
        evaluate: $99b18dd98d1424fc$var$evaluate.bind($99b18dd98d1424fc$var$evaluate, el)
    };
    let doCleanup = ()=>cleanups.forEach((i)=>i());
    return [
        utilities,
        doCleanup
    ];
}
function $99b18dd98d1424fc$var$getDirectiveHandler(el, directive2) {
    let noop = ()=>{};
    let handler4 = $99b18dd98d1424fc$var$directiveHandlers[directive2.type] || noop;
    let [utilities, cleanup2] = $99b18dd98d1424fc$var$getElementBoundUtilities(el);
    $99b18dd98d1424fc$var$onAttributeRemoved(el, directive2.original, cleanup2);
    let fullHandler = ()=>{
        if (el._x_ignore || el._x_ignoreSelf) return;
        handler4.inline && handler4.inline(el, directive2, utilities);
        handler4 = handler4.bind(handler4, el, directive2, utilities);
        $99b18dd98d1424fc$var$isDeferringHandlers ? $99b18dd98d1424fc$var$directiveHandlerStacks.get($99b18dd98d1424fc$var$currentHandlerStackKey).push(handler4) : handler4();
    };
    fullHandler.runCleanups = cleanup2;
    return fullHandler;
}
var $99b18dd98d1424fc$var$startingWith = (subject, replacement)=>({ name: name, value: value })=>{
        if (name.startsWith(subject)) name = name.replace(subject, replacement);
        return {
            name: name,
            value: value
        };
    };
var $99b18dd98d1424fc$var$into = (i)=>i;
function $99b18dd98d1424fc$var$toTransformedAttributes(callback = ()=>{}) {
    return ({ name: name, value: value })=>{
        let { name: newName, value: newValue } = $99b18dd98d1424fc$var$attributeTransformers.reduce((carry, transform)=>{
            return transform(carry);
        }, {
            name: name,
            value: value
        });
        if (newName !== name) callback(newName, name);
        return {
            name: newName,
            value: newValue
        };
    };
}
var $99b18dd98d1424fc$var$attributeTransformers = [];
function $99b18dd98d1424fc$var$mapAttributes(callback) {
    $99b18dd98d1424fc$var$attributeTransformers.push(callback);
}
function $99b18dd98d1424fc$var$outNonAlpineAttributes({ name: name }) {
    return $99b18dd98d1424fc$var$alpineAttributeRegex().test(name);
}
var $99b18dd98d1424fc$var$alpineAttributeRegex = ()=>new RegExp(`^${$99b18dd98d1424fc$var$prefixAsString}([^:^.]+)\\b`);
function $99b18dd98d1424fc$var$toParsedDirectives(transformedAttributeMap, originalAttributeOverride) {
    return ({ name: name, value: value })=>{
        let typeMatch = name.match($99b18dd98d1424fc$var$alpineAttributeRegex());
        let valueMatch = name.match(/:([a-zA-Z0-9\-_:]+)/);
        let modifiers = name.match(/\.[^.\]]+(?=[^\]]*$)/g) || [];
        let original = originalAttributeOverride || transformedAttributeMap[name] || name;
        return {
            type: typeMatch ? typeMatch[1] : null,
            value: valueMatch ? valueMatch[1] : null,
            modifiers: modifiers.map((i)=>i.replace(".", "")),
            expression: value,
            original: original
        };
    };
}
var $99b18dd98d1424fc$var$DEFAULT = "DEFAULT";
var $99b18dd98d1424fc$var$directiveOrder = [
    "ignore",
    "ref",
    "data",
    "id",
    "anchor",
    "bind",
    "init",
    "for",
    "model",
    "modelable",
    "transition",
    "show",
    "if",
    $99b18dd98d1424fc$var$DEFAULT,
    "teleport"
];
function $99b18dd98d1424fc$var$byPriority(a, b) {
    let typeA = $99b18dd98d1424fc$var$directiveOrder.indexOf(a.type) === -1 ? $99b18dd98d1424fc$var$DEFAULT : a.type;
    let typeB = $99b18dd98d1424fc$var$directiveOrder.indexOf(b.type) === -1 ? $99b18dd98d1424fc$var$DEFAULT : b.type;
    return $99b18dd98d1424fc$var$directiveOrder.indexOf(typeA) - $99b18dd98d1424fc$var$directiveOrder.indexOf(typeB);
}
// packages/alpinejs/src/utils/dispatch.js
function $99b18dd98d1424fc$var$dispatch(el, name, detail = {}) {
    el.dispatchEvent(new CustomEvent(name, {
        detail: detail,
        bubbles: true,
        // Allows events to pass the shadow DOM barrier.
        composed: true,
        cancelable: true
    }));
}
// packages/alpinejs/src/utils/walk.js
function $99b18dd98d1424fc$var$walk(el, callback) {
    if (typeof ShadowRoot === "function" && el instanceof ShadowRoot) {
        Array.from(el.children).forEach((el2)=>$99b18dd98d1424fc$var$walk(el2, callback));
        return;
    }
    let skip = false;
    callback(el, ()=>skip = true);
    if (skip) return;
    let node = el.firstElementChild;
    while(node){
        $99b18dd98d1424fc$var$walk(node, callback, false);
        node = node.nextElementSibling;
    }
}
// packages/alpinejs/src/utils/warn.js
function $99b18dd98d1424fc$var$warn(message, ...args) {
    console.warn(`Alpine Warning: ${message}`, ...args);
}
// packages/alpinejs/src/lifecycle.js
var $99b18dd98d1424fc$var$started = false;
function $99b18dd98d1424fc$var$start() {
    if ($99b18dd98d1424fc$var$started) $99b18dd98d1424fc$var$warn("Alpine has already been initialized on this page. Calling Alpine.start() more than once can cause problems.");
    $99b18dd98d1424fc$var$started = true;
    if (!document.body) $99b18dd98d1424fc$var$warn("Unable to initialize. Trying to load Alpine before `<body>` is available. Did you forget to add `defer` in Alpine's `<script>` tag?");
    $99b18dd98d1424fc$var$dispatch(document, "alpine:init");
    $99b18dd98d1424fc$var$dispatch(document, "alpine:initializing");
    $99b18dd98d1424fc$var$startObservingMutations();
    $99b18dd98d1424fc$var$onElAdded((el)=>$99b18dd98d1424fc$var$initTree(el, $99b18dd98d1424fc$var$walk));
    $99b18dd98d1424fc$var$onElRemoved((el)=>$99b18dd98d1424fc$var$destroyTree(el));
    $99b18dd98d1424fc$var$onAttributesAdded((el, attrs)=>{
        $99b18dd98d1424fc$var$directives(el, attrs).forEach((handle)=>handle());
    });
    let outNestedComponents = (el)=>!$99b18dd98d1424fc$var$closestRoot(el.parentElement, true);
    Array.from(document.querySelectorAll($99b18dd98d1424fc$var$allSelectors().join(","))).filter(outNestedComponents).forEach((el)=>{
        $99b18dd98d1424fc$var$initTree(el);
    });
    $99b18dd98d1424fc$var$dispatch(document, "alpine:initialized");
    setTimeout(()=>{
        $99b18dd98d1424fc$var$warnAboutMissingPlugins();
    });
}
var $99b18dd98d1424fc$var$rootSelectorCallbacks = [];
var $99b18dd98d1424fc$var$initSelectorCallbacks = [];
function $99b18dd98d1424fc$var$rootSelectors() {
    return $99b18dd98d1424fc$var$rootSelectorCallbacks.map((fn)=>fn());
}
function $99b18dd98d1424fc$var$allSelectors() {
    return $99b18dd98d1424fc$var$rootSelectorCallbacks.concat($99b18dd98d1424fc$var$initSelectorCallbacks).map((fn)=>fn());
}
function $99b18dd98d1424fc$var$addRootSelector(selectorCallback) {
    $99b18dd98d1424fc$var$rootSelectorCallbacks.push(selectorCallback);
}
function $99b18dd98d1424fc$var$addInitSelector(selectorCallback) {
    $99b18dd98d1424fc$var$initSelectorCallbacks.push(selectorCallback);
}
function $99b18dd98d1424fc$var$closestRoot(el, includeInitSelectors = false) {
    return $99b18dd98d1424fc$var$findClosest(el, (element)=>{
        const selectors = includeInitSelectors ? $99b18dd98d1424fc$var$allSelectors() : $99b18dd98d1424fc$var$rootSelectors();
        if (selectors.some((selector)=>element.matches(selector))) return true;
    });
}
function $99b18dd98d1424fc$var$findClosest(el, callback) {
    if (!el) return;
    if (callback(el)) return el;
    if (el._x_teleportBack) el = el._x_teleportBack;
    if (!el.parentElement) return;
    return $99b18dd98d1424fc$var$findClosest(el.parentElement, callback);
}
function $99b18dd98d1424fc$var$isRoot(el) {
    return $99b18dd98d1424fc$var$rootSelectors().some((selector)=>el.matches(selector));
}
var $99b18dd98d1424fc$var$initInterceptors2 = [];
function $99b18dd98d1424fc$var$interceptInit(callback) {
    $99b18dd98d1424fc$var$initInterceptors2.push(callback);
}
var $99b18dd98d1424fc$var$markerDispenser = 1;
function $99b18dd98d1424fc$var$initTree(el, walker = $99b18dd98d1424fc$var$walk, intercept = ()=>{}) {
    if ($99b18dd98d1424fc$var$findClosest(el, (i)=>i._x_ignore)) return;
    $99b18dd98d1424fc$var$deferHandlingDirectives(()=>{
        walker(el, (el2, skip)=>{
            if (el2._x_marker) return;
            intercept(el2, skip);
            $99b18dd98d1424fc$var$initInterceptors2.forEach((i)=>i(el2, skip));
            $99b18dd98d1424fc$var$directives(el2, el2.attributes).forEach((handle)=>handle());
            if (!el2._x_ignore) el2._x_marker = $99b18dd98d1424fc$var$markerDispenser++;
            el2._x_ignore && skip();
        });
    });
}
function $99b18dd98d1424fc$var$destroyTree(root, walker = $99b18dd98d1424fc$var$walk) {
    walker(root, (el)=>{
        $99b18dd98d1424fc$var$cleanupElement(el);
        $99b18dd98d1424fc$var$cleanupAttributes(el);
        delete el._x_marker;
    });
}
function $99b18dd98d1424fc$var$warnAboutMissingPlugins() {
    let pluginDirectives = [
        [
            "ui",
            "dialog",
            [
                "[x-dialog], [x-popover]"
            ]
        ],
        [
            "anchor",
            "anchor",
            [
                "[x-anchor]"
            ]
        ],
        [
            "sort",
            "sort",
            [
                "[x-sort]"
            ]
        ]
    ];
    pluginDirectives.forEach(([plugin2, directive2, selectors])=>{
        if ($99b18dd98d1424fc$var$directiveExists(directive2)) return;
        selectors.some((selector)=>{
            if (document.querySelector(selector)) {
                $99b18dd98d1424fc$var$warn(`found "${selector}", but missing ${plugin2} plugin`);
                return true;
            }
        });
    });
}
// packages/alpinejs/src/nextTick.js
var $99b18dd98d1424fc$var$tickStack = [];
var $99b18dd98d1424fc$var$isHolding = false;
function $99b18dd98d1424fc$var$nextTick(callback = ()=>{}) {
    queueMicrotask(()=>{
        $99b18dd98d1424fc$var$isHolding || setTimeout(()=>{
            $99b18dd98d1424fc$var$releaseNextTicks();
        });
    });
    return new Promise((res)=>{
        $99b18dd98d1424fc$var$tickStack.push(()=>{
            callback();
            res();
        });
    });
}
function $99b18dd98d1424fc$var$releaseNextTicks() {
    $99b18dd98d1424fc$var$isHolding = false;
    while($99b18dd98d1424fc$var$tickStack.length)$99b18dd98d1424fc$var$tickStack.shift()();
}
function $99b18dd98d1424fc$var$holdNextTicks() {
    $99b18dd98d1424fc$var$isHolding = true;
}
// packages/alpinejs/src/utils/classes.js
function $99b18dd98d1424fc$var$setClasses(el, value) {
    if (Array.isArray(value)) return $99b18dd98d1424fc$var$setClassesFromString(el, value.join(" "));
    else if (typeof value === "object" && value !== null) return $99b18dd98d1424fc$var$setClassesFromObject(el, value);
    else if (typeof value === "function") return $99b18dd98d1424fc$var$setClasses(el, value());
    return $99b18dd98d1424fc$var$setClassesFromString(el, value);
}
function $99b18dd98d1424fc$var$setClassesFromString(el, classString) {
    let split = (classString2)=>classString2.split(" ").filter(Boolean);
    let missingClasses = (classString2)=>classString2.split(" ").filter((i)=>!el.classList.contains(i)).filter(Boolean);
    let addClassesAndReturnUndo = (classes)=>{
        el.classList.add(...classes);
        return ()=>{
            el.classList.remove(...classes);
        };
    };
    classString = classString === true ? classString = "" : classString || "";
    return addClassesAndReturnUndo(missingClasses(classString));
}
function $99b18dd98d1424fc$var$setClassesFromObject(el, classObject) {
    let split = (classString)=>classString.split(" ").filter(Boolean);
    let forAdd = Object.entries(classObject).flatMap(([classString, bool])=>bool ? split(classString) : false).filter(Boolean);
    let forRemove = Object.entries(classObject).flatMap(([classString, bool])=>!bool ? split(classString) : false).filter(Boolean);
    let added = [];
    let removed = [];
    forRemove.forEach((i)=>{
        if (el.classList.contains(i)) {
            el.classList.remove(i);
            removed.push(i);
        }
    });
    forAdd.forEach((i)=>{
        if (!el.classList.contains(i)) {
            el.classList.add(i);
            added.push(i);
        }
    });
    return ()=>{
        removed.forEach((i)=>el.classList.add(i));
        added.forEach((i)=>el.classList.remove(i));
    };
}
// packages/alpinejs/src/utils/styles.js
function $99b18dd98d1424fc$var$setStyles(el, value) {
    if (typeof value === "object" && value !== null) return $99b18dd98d1424fc$var$setStylesFromObject(el, value);
    return $99b18dd98d1424fc$var$setStylesFromString(el, value);
}
function $99b18dd98d1424fc$var$setStylesFromObject(el, value) {
    let previousStyles = {};
    Object.entries(value).forEach(([key, value2])=>{
        previousStyles[key] = el.style[key];
        if (!key.startsWith("--")) key = $99b18dd98d1424fc$var$kebabCase(key);
        el.style.setProperty(key, value2);
    });
    setTimeout(()=>{
        if (el.style.length === 0) el.removeAttribute("style");
    });
    return ()=>{
        $99b18dd98d1424fc$var$setStyles(el, previousStyles);
    };
}
function $99b18dd98d1424fc$var$setStylesFromString(el, value) {
    let cache = el.getAttribute("style", value);
    el.setAttribute("style", value);
    return ()=>{
        el.setAttribute("style", cache || "");
    };
}
function $99b18dd98d1424fc$var$kebabCase(subject) {
    return subject.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
}
// packages/alpinejs/src/utils/once.js
function $99b18dd98d1424fc$var$once(callback, fallback = ()=>{}) {
    let called = false;
    return function() {
        if (!called) {
            called = true;
            callback.apply(this, arguments);
        } else fallback.apply(this, arguments);
    };
}
// packages/alpinejs/src/directives/x-transition.js
$99b18dd98d1424fc$var$directive("transition", (el, { value: value, modifiers: modifiers, expression: expression }, { evaluate: evaluate2 })=>{
    if (typeof expression === "function") expression = evaluate2(expression);
    if (expression === false) return;
    if (!expression || typeof expression === "boolean") $99b18dd98d1424fc$var$registerTransitionsFromHelper(el, modifiers, value);
    else $99b18dd98d1424fc$var$registerTransitionsFromClassString(el, expression, value);
});
function $99b18dd98d1424fc$var$registerTransitionsFromClassString(el, classString, stage) {
    $99b18dd98d1424fc$var$registerTransitionObject(el, $99b18dd98d1424fc$var$setClasses, "");
    let directiveStorageMap = {
        "enter": (classes)=>{
            el._x_transition.enter.during = classes;
        },
        "enter-start": (classes)=>{
            el._x_transition.enter.start = classes;
        },
        "enter-end": (classes)=>{
            el._x_transition.enter.end = classes;
        },
        "leave": (classes)=>{
            el._x_transition.leave.during = classes;
        },
        "leave-start": (classes)=>{
            el._x_transition.leave.start = classes;
        },
        "leave-end": (classes)=>{
            el._x_transition.leave.end = classes;
        }
    };
    directiveStorageMap[stage](classString);
}
function $99b18dd98d1424fc$var$registerTransitionsFromHelper(el, modifiers, stage) {
    $99b18dd98d1424fc$var$registerTransitionObject(el, $99b18dd98d1424fc$var$setStyles);
    let doesntSpecify = !modifiers.includes("in") && !modifiers.includes("out") && !stage;
    let transitioningIn = doesntSpecify || modifiers.includes("in") || [
        "enter"
    ].includes(stage);
    let transitioningOut = doesntSpecify || modifiers.includes("out") || [
        "leave"
    ].includes(stage);
    if (modifiers.includes("in") && !doesntSpecify) modifiers = modifiers.filter((i, index)=>index < modifiers.indexOf("out"));
    if (modifiers.includes("out") && !doesntSpecify) modifiers = modifiers.filter((i, index)=>index > modifiers.indexOf("out"));
    let wantsAll = !modifiers.includes("opacity") && !modifiers.includes("scale");
    let wantsOpacity = wantsAll || modifiers.includes("opacity");
    let wantsScale = wantsAll || modifiers.includes("scale");
    let opacityValue = wantsOpacity ? 0 : 1;
    let scaleValue = wantsScale ? $99b18dd98d1424fc$var$modifierValue(modifiers, "scale", 95) / 100 : 1;
    let delay = $99b18dd98d1424fc$var$modifierValue(modifiers, "delay", 0) / 1e3;
    let origin = $99b18dd98d1424fc$var$modifierValue(modifiers, "origin", "center");
    let property = "opacity, transform";
    let durationIn = $99b18dd98d1424fc$var$modifierValue(modifiers, "duration", 150) / 1e3;
    let durationOut = $99b18dd98d1424fc$var$modifierValue(modifiers, "duration", 75) / 1e3;
    let easing = `cubic-bezier(0.4, 0.0, 0.2, 1)`;
    if (transitioningIn) {
        el._x_transition.enter.during = {
            transformOrigin: origin,
            transitionDelay: `${delay}s`,
            transitionProperty: property,
            transitionDuration: `${durationIn}s`,
            transitionTimingFunction: easing
        };
        el._x_transition.enter.start = {
            opacity: opacityValue,
            transform: `scale(${scaleValue})`
        };
        el._x_transition.enter.end = {
            opacity: 1,
            transform: `scale(1)`
        };
    }
    if (transitioningOut) {
        el._x_transition.leave.during = {
            transformOrigin: origin,
            transitionDelay: `${delay}s`,
            transitionProperty: property,
            transitionDuration: `${durationOut}s`,
            transitionTimingFunction: easing
        };
        el._x_transition.leave.start = {
            opacity: 1,
            transform: `scale(1)`
        };
        el._x_transition.leave.end = {
            opacity: opacityValue,
            transform: `scale(${scaleValue})`
        };
    }
}
function $99b18dd98d1424fc$var$registerTransitionObject(el, setFunction, defaultValue = {}) {
    if (!el._x_transition) el._x_transition = {
        enter: {
            during: defaultValue,
            start: defaultValue,
            end: defaultValue
        },
        leave: {
            during: defaultValue,
            start: defaultValue,
            end: defaultValue
        },
        in (before = ()=>{}, after = ()=>{}) {
            $99b18dd98d1424fc$var$transition(el, setFunction, {
                during: this.enter.during,
                start: this.enter.start,
                end: this.enter.end
            }, before, after);
        },
        out (before = ()=>{}, after = ()=>{}) {
            $99b18dd98d1424fc$var$transition(el, setFunction, {
                during: this.leave.during,
                start: this.leave.start,
                end: this.leave.end
            }, before, after);
        }
    };
}
window.Element.prototype._x_toggleAndCascadeWithTransitions = function(el, value, show, hide) {
    const nextTick2 = document.visibilityState === "visible" ? requestAnimationFrame : setTimeout;
    let clickAwayCompatibleShow = ()=>nextTick2(show);
    if (value) {
        if (el._x_transition && (el._x_transition.enter || el._x_transition.leave)) el._x_transition.enter && (Object.entries(el._x_transition.enter.during).length || Object.entries(el._x_transition.enter.start).length || Object.entries(el._x_transition.enter.end).length) ? el._x_transition.in(show) : clickAwayCompatibleShow();
        else el._x_transition ? el._x_transition.in(show) : clickAwayCompatibleShow();
        return;
    }
    el._x_hidePromise = el._x_transition ? new Promise((resolve, reject)=>{
        el._x_transition.out(()=>{}, ()=>resolve(hide));
        el._x_transitioning && el._x_transitioning.beforeCancel(()=>reject({
                isFromCancelledTransition: true
            }));
    }) : Promise.resolve(hide);
    queueMicrotask(()=>{
        let closest = $99b18dd98d1424fc$var$closestHide(el);
        if (closest) {
            if (!closest._x_hideChildren) closest._x_hideChildren = [];
            closest._x_hideChildren.push(el);
        } else nextTick2(()=>{
            let hideAfterChildren = (el2)=>{
                let carry = Promise.all([
                    el2._x_hidePromise,
                    ...(el2._x_hideChildren || []).map(hideAfterChildren)
                ]).then(([i])=>i?.());
                delete el2._x_hidePromise;
                delete el2._x_hideChildren;
                return carry;
            };
            hideAfterChildren(el).catch((e)=>{
                if (!e.isFromCancelledTransition) throw e;
            });
        });
    });
};
function $99b18dd98d1424fc$var$closestHide(el) {
    let parent = el.parentNode;
    if (!parent) return;
    return parent._x_hidePromise ? parent : $99b18dd98d1424fc$var$closestHide(parent);
}
function $99b18dd98d1424fc$var$transition(el, setFunction, { during: during, start: start2, end: end } = {}, before = ()=>{}, after = ()=>{}) {
    if (el._x_transitioning) el._x_transitioning.cancel();
    if (Object.keys(during).length === 0 && Object.keys(start2).length === 0 && Object.keys(end).length === 0) {
        before();
        after();
        return;
    }
    let undoStart, undoDuring, undoEnd;
    $99b18dd98d1424fc$var$performTransition(el, {
        start () {
            undoStart = setFunction(el, start2);
        },
        during () {
            undoDuring = setFunction(el, during);
        },
        before: before,
        end () {
            undoStart();
            undoEnd = setFunction(el, end);
        },
        after: after,
        cleanup () {
            undoDuring();
            undoEnd();
        }
    });
}
function $99b18dd98d1424fc$var$performTransition(el, stages) {
    let interrupted, reachedBefore, reachedEnd;
    let finish = $99b18dd98d1424fc$var$once(()=>{
        $99b18dd98d1424fc$var$mutateDom(()=>{
            interrupted = true;
            if (!reachedBefore) stages.before();
            if (!reachedEnd) {
                stages.end();
                $99b18dd98d1424fc$var$releaseNextTicks();
            }
            stages.after();
            if (el.isConnected) stages.cleanup();
            delete el._x_transitioning;
        });
    });
    el._x_transitioning = {
        beforeCancels: [],
        beforeCancel (callback) {
            this.beforeCancels.push(callback);
        },
        cancel: $99b18dd98d1424fc$var$once(function() {
            while(this.beforeCancels.length)this.beforeCancels.shift()();
            finish();
        }),
        finish: finish
    };
    $99b18dd98d1424fc$var$mutateDom(()=>{
        stages.start();
        stages.during();
    });
    $99b18dd98d1424fc$var$holdNextTicks();
    requestAnimationFrame(()=>{
        if (interrupted) return;
        let duration = Number(getComputedStyle(el).transitionDuration.replace(/,.*/, "").replace("s", "")) * 1e3;
        let delay = Number(getComputedStyle(el).transitionDelay.replace(/,.*/, "").replace("s", "")) * 1e3;
        if (duration === 0) duration = Number(getComputedStyle(el).animationDuration.replace("s", "")) * 1e3;
        $99b18dd98d1424fc$var$mutateDom(()=>{
            stages.before();
        });
        reachedBefore = true;
        requestAnimationFrame(()=>{
            if (interrupted) return;
            $99b18dd98d1424fc$var$mutateDom(()=>{
                stages.end();
            });
            $99b18dd98d1424fc$var$releaseNextTicks();
            setTimeout(el._x_transitioning.finish, duration + delay);
            reachedEnd = true;
        });
    });
}
function $99b18dd98d1424fc$var$modifierValue(modifiers, key, fallback) {
    if (modifiers.indexOf(key) === -1) return fallback;
    const rawValue = modifiers[modifiers.indexOf(key) + 1];
    if (!rawValue) return fallback;
    if (key === "scale") {
        if (isNaN(rawValue)) return fallback;
    }
    if (key === "duration" || key === "delay") {
        let match = rawValue.match(/([0-9]+)ms/);
        if (match) return match[1];
    }
    if (key === "origin") {
        if ([
            "top",
            "right",
            "left",
            "center",
            "bottom"
        ].includes(modifiers[modifiers.indexOf(key) + 2])) return [
            rawValue,
            modifiers[modifiers.indexOf(key) + 2]
        ].join(" ");
    }
    return rawValue;
}
// packages/alpinejs/src/clone.js
var $99b18dd98d1424fc$var$isCloning = false;
function $99b18dd98d1424fc$var$skipDuringClone(callback, fallback = ()=>{}) {
    return (...args)=>$99b18dd98d1424fc$var$isCloning ? fallback(...args) : callback(...args);
}
function $99b18dd98d1424fc$var$onlyDuringClone(callback) {
    return (...args)=>$99b18dd98d1424fc$var$isCloning && callback(...args);
}
var $99b18dd98d1424fc$var$interceptors = [];
function $99b18dd98d1424fc$var$interceptClone(callback) {
    $99b18dd98d1424fc$var$interceptors.push(callback);
}
function $99b18dd98d1424fc$var$cloneNode(from, to) {
    $99b18dd98d1424fc$var$interceptors.forEach((i)=>i(from, to));
    $99b18dd98d1424fc$var$isCloning = true;
    $99b18dd98d1424fc$var$dontRegisterReactiveSideEffects(()=>{
        $99b18dd98d1424fc$var$initTree(to, (el, callback)=>{
            callback(el, ()=>{});
        });
    });
    $99b18dd98d1424fc$var$isCloning = false;
}
var $99b18dd98d1424fc$var$isCloningLegacy = false;
function $99b18dd98d1424fc$var$clone(oldEl, newEl) {
    if (!newEl._x_dataStack) newEl._x_dataStack = oldEl._x_dataStack;
    $99b18dd98d1424fc$var$isCloning = true;
    $99b18dd98d1424fc$var$isCloningLegacy = true;
    $99b18dd98d1424fc$var$dontRegisterReactiveSideEffects(()=>{
        $99b18dd98d1424fc$var$cloneTree(newEl);
    });
    $99b18dd98d1424fc$var$isCloning = false;
    $99b18dd98d1424fc$var$isCloningLegacy = false;
}
function $99b18dd98d1424fc$var$cloneTree(el) {
    let hasRunThroughFirstEl = false;
    let shallowWalker = (el2, callback)=>{
        $99b18dd98d1424fc$var$walk(el2, (el3, skip)=>{
            if (hasRunThroughFirstEl && $99b18dd98d1424fc$var$isRoot(el3)) return skip();
            hasRunThroughFirstEl = true;
            callback(el3, skip);
        });
    };
    $99b18dd98d1424fc$var$initTree(el, shallowWalker);
}
function $99b18dd98d1424fc$var$dontRegisterReactiveSideEffects(callback) {
    let cache = $99b18dd98d1424fc$var$effect;
    $99b18dd98d1424fc$var$overrideEffect((callback2, el)=>{
        let storedEffect = cache(callback2);
        $99b18dd98d1424fc$var$release(storedEffect);
        return ()=>{};
    });
    callback();
    $99b18dd98d1424fc$var$overrideEffect(cache);
}
// packages/alpinejs/src/utils/bind.js
function $99b18dd98d1424fc$var$bind(el, name, value, modifiers = []) {
    if (!el._x_bindings) el._x_bindings = $99b18dd98d1424fc$var$reactive({});
    el._x_bindings[name] = value;
    name = modifiers.includes("camel") ? $99b18dd98d1424fc$var$camelCase(name) : name;
    switch(name){
        case "value":
            $99b18dd98d1424fc$var$bindInputValue(el, value);
            break;
        case "style":
            $99b18dd98d1424fc$var$bindStyles(el, value);
            break;
        case "class":
            $99b18dd98d1424fc$var$bindClasses(el, value);
            break;
        case "selected":
        case "checked":
            $99b18dd98d1424fc$var$bindAttributeAndProperty(el, name, value);
            break;
        default:
            $99b18dd98d1424fc$var$bindAttribute(el, name, value);
            break;
    }
}
function $99b18dd98d1424fc$var$bindInputValue(el, value) {
    if ($99b18dd98d1424fc$var$isRadio(el)) {
        if (el.attributes.value === void 0) el.value = value;
        if (window.fromModel) {
            if (typeof value === "boolean") el.checked = $99b18dd98d1424fc$var$safeParseBoolean(el.value) === value;
            else el.checked = $99b18dd98d1424fc$var$checkedAttrLooseCompare(el.value, value);
        }
    } else if ($99b18dd98d1424fc$var$isCheckbox(el)) {
        if (Number.isInteger(value)) el.value = value;
        else if (!Array.isArray(value) && typeof value !== "boolean" && ![
            null,
            void 0
        ].includes(value)) el.value = String(value);
        else if (Array.isArray(value)) el.checked = value.some((val)=>$99b18dd98d1424fc$var$checkedAttrLooseCompare(val, el.value));
        else el.checked = !!value;
    } else if (el.tagName === "SELECT") $99b18dd98d1424fc$var$updateSelect(el, value);
    else {
        if (el.value === value) return;
        el.value = value === void 0 ? "" : value;
    }
}
function $99b18dd98d1424fc$var$bindClasses(el, value) {
    if (el._x_undoAddedClasses) el._x_undoAddedClasses();
    el._x_undoAddedClasses = $99b18dd98d1424fc$var$setClasses(el, value);
}
function $99b18dd98d1424fc$var$bindStyles(el, value) {
    if (el._x_undoAddedStyles) el._x_undoAddedStyles();
    el._x_undoAddedStyles = $99b18dd98d1424fc$var$setStyles(el, value);
}
function $99b18dd98d1424fc$var$bindAttributeAndProperty(el, name, value) {
    $99b18dd98d1424fc$var$bindAttribute(el, name, value);
    $99b18dd98d1424fc$var$setPropertyIfChanged(el, name, value);
}
function $99b18dd98d1424fc$var$bindAttribute(el, name, value) {
    if ([
        null,
        void 0,
        false
    ].includes(value) && $99b18dd98d1424fc$var$attributeShouldntBePreservedIfFalsy(name)) el.removeAttribute(name);
    else {
        if ($99b18dd98d1424fc$var$isBooleanAttr(name)) value = name;
        $99b18dd98d1424fc$var$setIfChanged(el, name, value);
    }
}
function $99b18dd98d1424fc$var$setIfChanged(el, attrName, value) {
    if (el.getAttribute(attrName) != value) el.setAttribute(attrName, value);
}
function $99b18dd98d1424fc$var$setPropertyIfChanged(el, propName, value) {
    if (el[propName] !== value) el[propName] = value;
}
function $99b18dd98d1424fc$var$updateSelect(el, value) {
    const arrayWrappedValue = [].concat(value).map((value2)=>{
        return value2 + "";
    });
    Array.from(el.options).forEach((option)=>{
        option.selected = arrayWrappedValue.includes(option.value);
    });
}
function $99b18dd98d1424fc$var$camelCase(subject) {
    return subject.toLowerCase().replace(/-(\w)/g, (match, char)=>char.toUpperCase());
}
function $99b18dd98d1424fc$var$checkedAttrLooseCompare(valueA, valueB) {
    return valueA == valueB;
}
function $99b18dd98d1424fc$var$safeParseBoolean(rawValue) {
    if ([
        1,
        "1",
        "true",
        "on",
        "yes",
        true
    ].includes(rawValue)) return true;
    if ([
        0,
        "0",
        "false",
        "off",
        "no",
        false
    ].includes(rawValue)) return false;
    return rawValue ? Boolean(rawValue) : null;
}
var $99b18dd98d1424fc$var$booleanAttributes = /* @__PURE__ */ new Set([
    "allowfullscreen",
    "async",
    "autofocus",
    "autoplay",
    "checked",
    "controls",
    "default",
    "defer",
    "disabled",
    "formnovalidate",
    "inert",
    "ismap",
    "itemscope",
    "loop",
    "multiple",
    "muted",
    "nomodule",
    "novalidate",
    "open",
    "playsinline",
    "readonly",
    "required",
    "reversed",
    "selected",
    "shadowrootclonable",
    "shadowrootdelegatesfocus",
    "shadowrootserializable"
]);
function $99b18dd98d1424fc$var$isBooleanAttr(attrName) {
    return $99b18dd98d1424fc$var$booleanAttributes.has(attrName);
}
function $99b18dd98d1424fc$var$attributeShouldntBePreservedIfFalsy(name) {
    return ![
        "aria-pressed",
        "aria-checked",
        "aria-expanded",
        "aria-selected"
    ].includes(name);
}
function $99b18dd98d1424fc$var$getBinding(el, name, fallback) {
    if (el._x_bindings && el._x_bindings[name] !== void 0) return el._x_bindings[name];
    return $99b18dd98d1424fc$var$getAttributeBinding(el, name, fallback);
}
function $99b18dd98d1424fc$var$extractProp(el, name, fallback, extract = true) {
    if (el._x_bindings && el._x_bindings[name] !== void 0) return el._x_bindings[name];
    if (el._x_inlineBindings && el._x_inlineBindings[name] !== void 0) {
        let binding = el._x_inlineBindings[name];
        binding.extract = extract;
        return $99b18dd98d1424fc$var$dontAutoEvaluateFunctions(()=>{
            return $99b18dd98d1424fc$var$evaluate(el, binding.expression);
        });
    }
    return $99b18dd98d1424fc$var$getAttributeBinding(el, name, fallback);
}
function $99b18dd98d1424fc$var$getAttributeBinding(el, name, fallback) {
    let attr = el.getAttribute(name);
    if (attr === null) return typeof fallback === "function" ? fallback() : fallback;
    if (attr === "") return true;
    if ($99b18dd98d1424fc$var$isBooleanAttr(name)) return !![
        name,
        "true"
    ].includes(attr);
    return attr;
}
function $99b18dd98d1424fc$var$isCheckbox(el) {
    return el.type === "checkbox" || el.localName === "ui-checkbox" || el.localName === "ui-switch";
}
function $99b18dd98d1424fc$var$isRadio(el) {
    return el.type === "radio" || el.localName === "ui-radio";
}
// packages/alpinejs/src/utils/debounce.js
function $99b18dd98d1424fc$var$debounce(func, wait) {
    var timeout;
    return function() {
        var context = this, args = arguments;
        var later = function() {
            timeout = null;
            func.apply(context, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    };
}
// packages/alpinejs/src/utils/throttle.js
function $99b18dd98d1424fc$var$throttle(func, limit) {
    let inThrottle;
    return function() {
        let context = this, args = arguments;
        if (!inThrottle) {
            func.apply(context, args);
            inThrottle = true;
            setTimeout(()=>inThrottle = false, limit);
        }
    };
}
// packages/alpinejs/src/entangle.js
function $99b18dd98d1424fc$var$entangle({ get: outerGet, set: outerSet }, { get: innerGet, set: innerSet }) {
    let firstRun = true;
    let outerHash;
    let innerHash;
    let reference = $99b18dd98d1424fc$var$effect(()=>{
        let outer = outerGet();
        let inner = innerGet();
        if (firstRun) {
            innerSet($99b18dd98d1424fc$var$cloneIfObject(outer));
            firstRun = false;
        } else {
            let outerHashLatest = JSON.stringify(outer);
            let innerHashLatest = JSON.stringify(inner);
            if (outerHashLatest !== outerHash) innerSet($99b18dd98d1424fc$var$cloneIfObject(outer));
            else if (outerHashLatest !== innerHashLatest) outerSet($99b18dd98d1424fc$var$cloneIfObject(inner));
        }
        outerHash = JSON.stringify(outerGet());
        innerHash = JSON.stringify(innerGet());
    });
    return ()=>{
        $99b18dd98d1424fc$var$release(reference);
    };
}
function $99b18dd98d1424fc$var$cloneIfObject(value) {
    return typeof value === "object" ? JSON.parse(JSON.stringify(value)) : value;
}
// packages/alpinejs/src/plugin.js
function $99b18dd98d1424fc$var$plugin(callback) {
    let callbacks = Array.isArray(callback) ? callback : [
        callback
    ];
    callbacks.forEach((i)=>i($99b18dd98d1424fc$var$alpine_default));
}
// packages/alpinejs/src/store.js
var $99b18dd98d1424fc$var$stores = {};
var $99b18dd98d1424fc$var$isReactive = false;
function $99b18dd98d1424fc$var$store(name, value) {
    if (!$99b18dd98d1424fc$var$isReactive) {
        $99b18dd98d1424fc$var$stores = $99b18dd98d1424fc$var$reactive($99b18dd98d1424fc$var$stores);
        $99b18dd98d1424fc$var$isReactive = true;
    }
    if (value === void 0) return $99b18dd98d1424fc$var$stores[name];
    $99b18dd98d1424fc$var$stores[name] = value;
    $99b18dd98d1424fc$var$initInterceptors($99b18dd98d1424fc$var$stores[name]);
    if (typeof value === "object" && value !== null && value.hasOwnProperty("init") && typeof value.init === "function") $99b18dd98d1424fc$var$stores[name].init();
}
function $99b18dd98d1424fc$var$getStores() {
    return $99b18dd98d1424fc$var$stores;
}
// packages/alpinejs/src/binds.js
var $99b18dd98d1424fc$var$binds = {};
function $99b18dd98d1424fc$var$bind2(name, bindings) {
    let getBindings = typeof bindings !== "function" ? ()=>bindings : bindings;
    if (name instanceof Element) return $99b18dd98d1424fc$var$applyBindingsObject(name, getBindings());
    else $99b18dd98d1424fc$var$binds[name] = getBindings;
    return ()=>{};
}
function $99b18dd98d1424fc$var$injectBindingProviders(obj) {
    Object.entries($99b18dd98d1424fc$var$binds).forEach(([name, callback])=>{
        Object.defineProperty(obj, name, {
            get () {
                return (...args)=>{
                    return callback(...args);
                };
            }
        });
    });
    return obj;
}
function $99b18dd98d1424fc$var$applyBindingsObject(el, obj, original) {
    let cleanupRunners = [];
    while(cleanupRunners.length)cleanupRunners.pop()();
    let attributes = Object.entries(obj).map(([name, value])=>({
            name: name,
            value: value
        }));
    let staticAttributes = $99b18dd98d1424fc$var$attributesOnly(attributes);
    attributes = attributes.map((attribute)=>{
        if (staticAttributes.find((attr)=>attr.name === attribute.name)) return {
            name: `x-bind:${attribute.name}`,
            value: `"${attribute.value}"`
        };
        return attribute;
    });
    $99b18dd98d1424fc$var$directives(el, attributes, original).map((handle)=>{
        cleanupRunners.push(handle.runCleanups);
        handle();
    });
    return ()=>{
        while(cleanupRunners.length)cleanupRunners.pop()();
    };
}
// packages/alpinejs/src/datas.js
var $99b18dd98d1424fc$var$datas = {};
function $99b18dd98d1424fc$var$data(name, callback) {
    $99b18dd98d1424fc$var$datas[name] = callback;
}
function $99b18dd98d1424fc$var$injectDataProviders(obj, context) {
    Object.entries($99b18dd98d1424fc$var$datas).forEach(([name, callback])=>{
        Object.defineProperty(obj, name, {
            get () {
                return (...args)=>{
                    return callback.bind(context)(...args);
                };
            },
            enumerable: false
        });
    });
    return obj;
}
// packages/alpinejs/src/alpine.js
var $99b18dd98d1424fc$var$Alpine = {
    get reactive () {
        return $99b18dd98d1424fc$var$reactive;
    },
    get release () {
        return $99b18dd98d1424fc$var$release;
    },
    get effect () {
        return $99b18dd98d1424fc$var$effect;
    },
    get raw () {
        return $99b18dd98d1424fc$var$raw;
    },
    version: "3.14.8",
    flushAndStopDeferringMutations: $99b18dd98d1424fc$var$flushAndStopDeferringMutations,
    dontAutoEvaluateFunctions: $99b18dd98d1424fc$var$dontAutoEvaluateFunctions,
    disableEffectScheduling: $99b18dd98d1424fc$var$disableEffectScheduling,
    startObservingMutations: $99b18dd98d1424fc$var$startObservingMutations,
    stopObservingMutations: $99b18dd98d1424fc$var$stopObservingMutations,
    setReactivityEngine: $99b18dd98d1424fc$var$setReactivityEngine,
    onAttributeRemoved: $99b18dd98d1424fc$var$onAttributeRemoved,
    onAttributesAdded: $99b18dd98d1424fc$var$onAttributesAdded,
    closestDataStack: $99b18dd98d1424fc$var$closestDataStack,
    skipDuringClone: $99b18dd98d1424fc$var$skipDuringClone,
    onlyDuringClone: $99b18dd98d1424fc$var$onlyDuringClone,
    addRootSelector: $99b18dd98d1424fc$var$addRootSelector,
    addInitSelector: $99b18dd98d1424fc$var$addInitSelector,
    interceptClone: $99b18dd98d1424fc$var$interceptClone,
    addScopeToNode: $99b18dd98d1424fc$var$addScopeToNode,
    deferMutations: $99b18dd98d1424fc$var$deferMutations,
    mapAttributes: $99b18dd98d1424fc$var$mapAttributes,
    evaluateLater: $99b18dd98d1424fc$var$evaluateLater,
    interceptInit: $99b18dd98d1424fc$var$interceptInit,
    setEvaluator: $99b18dd98d1424fc$var$setEvaluator,
    mergeProxies: $99b18dd98d1424fc$var$mergeProxies,
    extractProp: $99b18dd98d1424fc$var$extractProp,
    findClosest: $99b18dd98d1424fc$var$findClosest,
    onElRemoved: $99b18dd98d1424fc$var$onElRemoved,
    closestRoot: $99b18dd98d1424fc$var$closestRoot,
    destroyTree: $99b18dd98d1424fc$var$destroyTree,
    interceptor: $99b18dd98d1424fc$var$interceptor,
    transition: // INTERNAL: not public API and is subject to change without major release.
    $99b18dd98d1424fc$var$transition,
    setStyles: // INTERNAL
    $99b18dd98d1424fc$var$setStyles,
    mutateDom: // INTERNAL
    $99b18dd98d1424fc$var$mutateDom,
    directive: $99b18dd98d1424fc$var$directive,
    entangle: $99b18dd98d1424fc$var$entangle,
    throttle: $99b18dd98d1424fc$var$throttle,
    debounce: $99b18dd98d1424fc$var$debounce,
    evaluate: $99b18dd98d1424fc$var$evaluate,
    initTree: $99b18dd98d1424fc$var$initTree,
    nextTick: $99b18dd98d1424fc$var$nextTick,
    prefixed: $99b18dd98d1424fc$var$prefix,
    prefix: $99b18dd98d1424fc$var$setPrefix,
    plugin: $99b18dd98d1424fc$var$plugin,
    magic: $99b18dd98d1424fc$var$magic,
    store: $99b18dd98d1424fc$var$store,
    start: $99b18dd98d1424fc$var$start,
    clone: $99b18dd98d1424fc$var$clone,
    cloneNode: // INTERNAL
    $99b18dd98d1424fc$var$cloneNode,
    // INTERNAL
    bound: $99b18dd98d1424fc$var$getBinding,
    $data: $99b18dd98d1424fc$var$scope,
    watch: $99b18dd98d1424fc$var$watch,
    walk: $99b18dd98d1424fc$var$walk,
    data: $99b18dd98d1424fc$var$data,
    bind: $99b18dd98d1424fc$var$bind2
};
var $99b18dd98d1424fc$var$alpine_default = $99b18dd98d1424fc$var$Alpine;
// node_modules/@vue/shared/dist/shared.esm-bundler.js
function $99b18dd98d1424fc$var$makeMap(str, expectsLowerCase) {
    const map = /* @__PURE__ */ Object.create(null);
    const list = str.split(",");
    for(let i = 0; i < list.length; i++)map[list[i]] = true;
    return expectsLowerCase ? (val)=>!!map[val.toLowerCase()] : (val)=>!!map[val];
}
var $99b18dd98d1424fc$var$specialBooleanAttrs = `itemscope,allowfullscreen,formnovalidate,ismap,nomodule,novalidate,readonly`;
var $99b18dd98d1424fc$var$isBooleanAttr2 = /* @__PURE__ */ $99b18dd98d1424fc$var$makeMap($99b18dd98d1424fc$var$specialBooleanAttrs + `,async,autofocus,autoplay,controls,default,defer,disabled,hidden,loop,open,required,reversed,scoped,seamless,checked,muted,multiple,selected`);
var $99b18dd98d1424fc$var$EMPTY_OBJ = Object.freeze({});
var $99b18dd98d1424fc$var$EMPTY_ARR = Object.freeze([]);
var $99b18dd98d1424fc$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $99b18dd98d1424fc$var$hasOwn = (val, key)=>$99b18dd98d1424fc$var$hasOwnProperty.call(val, key);
var $99b18dd98d1424fc$var$isArray = Array.isArray;
var $99b18dd98d1424fc$var$isMap = (val)=>$99b18dd98d1424fc$var$toTypeString(val) === "[object Map]";
var $99b18dd98d1424fc$var$isString = (val)=>typeof val === "string";
var $99b18dd98d1424fc$var$isSymbol = (val)=>typeof val === "symbol";
var $99b18dd98d1424fc$var$isObject = (val)=>val !== null && typeof val === "object";
var $99b18dd98d1424fc$var$objectToString = Object.prototype.toString;
var $99b18dd98d1424fc$var$toTypeString = (value)=>$99b18dd98d1424fc$var$objectToString.call(value);
var $99b18dd98d1424fc$var$toRawType = (value)=>{
    return $99b18dd98d1424fc$var$toTypeString(value).slice(8, -1);
};
var $99b18dd98d1424fc$var$isIntegerKey = (key)=>$99b18dd98d1424fc$var$isString(key) && key !== "NaN" && key[0] !== "-" && "" + parseInt(key, 10) === key;
var $99b18dd98d1424fc$var$cacheStringFunction = (fn)=>{
    const cache = /* @__PURE__ */ Object.create(null);
    return (str)=>{
        const hit = cache[str];
        return hit || (cache[str] = fn(str));
    };
};
var $99b18dd98d1424fc$var$camelizeRE = /-(\w)/g;
var $99b18dd98d1424fc$var$camelize = $99b18dd98d1424fc$var$cacheStringFunction((str)=>{
    return str.replace($99b18dd98d1424fc$var$camelizeRE, (_, c)=>c ? c.toUpperCase() : "");
});
var $99b18dd98d1424fc$var$hyphenateRE = /\B([A-Z])/g;
var $99b18dd98d1424fc$var$hyphenate = $99b18dd98d1424fc$var$cacheStringFunction((str)=>str.replace($99b18dd98d1424fc$var$hyphenateRE, "-$1").toLowerCase());
var $99b18dd98d1424fc$var$capitalize = $99b18dd98d1424fc$var$cacheStringFunction((str)=>str.charAt(0).toUpperCase() + str.slice(1));
var $99b18dd98d1424fc$var$toHandlerKey = $99b18dd98d1424fc$var$cacheStringFunction((str)=>str ? `on${$99b18dd98d1424fc$var$capitalize(str)}` : ``);
var $99b18dd98d1424fc$var$hasChanged = (value, oldValue)=>value !== oldValue && (value === value || oldValue === oldValue);
// node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js
var $99b18dd98d1424fc$var$targetMap = /* @__PURE__ */ new WeakMap();
var $99b18dd98d1424fc$var$effectStack = [];
var $99b18dd98d1424fc$var$activeEffect;
var $99b18dd98d1424fc$var$ITERATE_KEY = Symbol("iterate");
var $99b18dd98d1424fc$var$MAP_KEY_ITERATE_KEY = Symbol("Map key iterate");
function $99b18dd98d1424fc$var$isEffect(fn) {
    return fn && fn._isEffect === true;
}
function $99b18dd98d1424fc$var$effect2(fn, options = $99b18dd98d1424fc$var$EMPTY_OBJ) {
    if ($99b18dd98d1424fc$var$isEffect(fn)) fn = fn.raw;
    const effect3 = $99b18dd98d1424fc$var$createReactiveEffect(fn, options);
    if (!options.lazy) effect3();
    return effect3;
}
function $99b18dd98d1424fc$var$stop(effect3) {
    if (effect3.active) {
        $99b18dd98d1424fc$var$cleanup(effect3);
        if (effect3.options.onStop) effect3.options.onStop();
        effect3.active = false;
    }
}
var $99b18dd98d1424fc$var$uid = 0;
function $99b18dd98d1424fc$var$createReactiveEffect(fn, options) {
    const effect3 = function reactiveEffect() {
        if (!effect3.active) return fn();
        if (!$99b18dd98d1424fc$var$effectStack.includes(effect3)) {
            $99b18dd98d1424fc$var$cleanup(effect3);
            try {
                $99b18dd98d1424fc$var$enableTracking();
                $99b18dd98d1424fc$var$effectStack.push(effect3);
                $99b18dd98d1424fc$var$activeEffect = effect3;
                return fn();
            } finally{
                $99b18dd98d1424fc$var$effectStack.pop();
                $99b18dd98d1424fc$var$resetTracking();
                $99b18dd98d1424fc$var$activeEffect = $99b18dd98d1424fc$var$effectStack[$99b18dd98d1424fc$var$effectStack.length - 1];
            }
        }
    };
    effect3.id = $99b18dd98d1424fc$var$uid++;
    effect3.allowRecurse = !!options.allowRecurse;
    effect3._isEffect = true;
    effect3.active = true;
    effect3.raw = fn;
    effect3.deps = [];
    effect3.options = options;
    return effect3;
}
function $99b18dd98d1424fc$var$cleanup(effect3) {
    const { deps: deps } = effect3;
    if (deps.length) {
        for(let i = 0; i < deps.length; i++)deps[i].delete(effect3);
        deps.length = 0;
    }
}
var $99b18dd98d1424fc$var$shouldTrack = true;
var $99b18dd98d1424fc$var$trackStack = [];
function $99b18dd98d1424fc$var$pauseTracking() {
    $99b18dd98d1424fc$var$trackStack.push($99b18dd98d1424fc$var$shouldTrack);
    $99b18dd98d1424fc$var$shouldTrack = false;
}
function $99b18dd98d1424fc$var$enableTracking() {
    $99b18dd98d1424fc$var$trackStack.push($99b18dd98d1424fc$var$shouldTrack);
    $99b18dd98d1424fc$var$shouldTrack = true;
}
function $99b18dd98d1424fc$var$resetTracking() {
    const last = $99b18dd98d1424fc$var$trackStack.pop();
    $99b18dd98d1424fc$var$shouldTrack = last === void 0 ? true : last;
}
function $99b18dd98d1424fc$var$track(target, type, key) {
    if (!$99b18dd98d1424fc$var$shouldTrack || $99b18dd98d1424fc$var$activeEffect === void 0) return;
    let depsMap = $99b18dd98d1424fc$var$targetMap.get(target);
    if (!depsMap) $99b18dd98d1424fc$var$targetMap.set(target, depsMap = /* @__PURE__ */ new Map());
    let dep = depsMap.get(key);
    if (!dep) depsMap.set(key, dep = /* @__PURE__ */ new Set());
    if (!dep.has($99b18dd98d1424fc$var$activeEffect)) {
        dep.add($99b18dd98d1424fc$var$activeEffect);
        $99b18dd98d1424fc$var$activeEffect.deps.push(dep);
        if ($99b18dd98d1424fc$var$activeEffect.options.onTrack) $99b18dd98d1424fc$var$activeEffect.options.onTrack({
            effect: $99b18dd98d1424fc$var$activeEffect,
            target: target,
            type: type,
            key: key
        });
    }
}
function $99b18dd98d1424fc$var$trigger(target, type, key, newValue, oldValue, oldTarget) {
    const depsMap = $99b18dd98d1424fc$var$targetMap.get(target);
    if (!depsMap) return;
    const effects = /* @__PURE__ */ new Set();
    const add2 = (effectsToAdd)=>{
        if (effectsToAdd) effectsToAdd.forEach((effect3)=>{
            if (effect3 !== $99b18dd98d1424fc$var$activeEffect || effect3.allowRecurse) effects.add(effect3);
        });
    };
    if (type === "clear") depsMap.forEach(add2);
    else if (key === "length" && $99b18dd98d1424fc$var$isArray(target)) depsMap.forEach((dep, key2)=>{
        if (key2 === "length" || key2 >= newValue) add2(dep);
    });
    else {
        if (key !== void 0) add2(depsMap.get(key));
        switch(type){
            case "add":
                if (!$99b18dd98d1424fc$var$isArray(target)) {
                    add2(depsMap.get($99b18dd98d1424fc$var$ITERATE_KEY));
                    if ($99b18dd98d1424fc$var$isMap(target)) add2(depsMap.get($99b18dd98d1424fc$var$MAP_KEY_ITERATE_KEY));
                } else if ($99b18dd98d1424fc$var$isIntegerKey(key)) add2(depsMap.get("length"));
                break;
            case "delete":
                if (!$99b18dd98d1424fc$var$isArray(target)) {
                    add2(depsMap.get($99b18dd98d1424fc$var$ITERATE_KEY));
                    if ($99b18dd98d1424fc$var$isMap(target)) add2(depsMap.get($99b18dd98d1424fc$var$MAP_KEY_ITERATE_KEY));
                }
                break;
            case "set":
                if ($99b18dd98d1424fc$var$isMap(target)) add2(depsMap.get($99b18dd98d1424fc$var$ITERATE_KEY));
                break;
        }
    }
    const run = (effect3)=>{
        if (effect3.options.onTrigger) effect3.options.onTrigger({
            effect: effect3,
            target: target,
            key: key,
            type: type,
            newValue: newValue,
            oldValue: oldValue,
            oldTarget: oldTarget
        });
        if (effect3.options.scheduler) effect3.options.scheduler(effect3);
        else effect3();
    };
    effects.forEach(run);
}
var $99b18dd98d1424fc$var$isNonTrackableKeys = /* @__PURE__ */ $99b18dd98d1424fc$var$makeMap(`__proto__,__v_isRef,__isVue`);
var $99b18dd98d1424fc$var$builtInSymbols = new Set(Object.getOwnPropertyNames(Symbol).map((key)=>Symbol[key]).filter($99b18dd98d1424fc$var$isSymbol));
var $99b18dd98d1424fc$var$get2 = /* @__PURE__ */ $99b18dd98d1424fc$var$createGetter();
var $99b18dd98d1424fc$var$readonlyGet = /* @__PURE__ */ $99b18dd98d1424fc$var$createGetter(true);
var $99b18dd98d1424fc$var$arrayInstrumentations = /* @__PURE__ */ $99b18dd98d1424fc$var$createArrayInstrumentations();
function $99b18dd98d1424fc$var$createArrayInstrumentations() {
    const instrumentations = {};
    [
        "includes",
        "indexOf",
        "lastIndexOf"
    ].forEach((key)=>{
        instrumentations[key] = function(...args) {
            const arr = $99b18dd98d1424fc$var$toRaw(this);
            for(let i = 0, l = this.length; i < l; i++)$99b18dd98d1424fc$var$track(arr, "get", i + "");
            const res = arr[key](...args);
            if (res === -1 || res === false) return arr[key](...args.map($99b18dd98d1424fc$var$toRaw));
            else return res;
        };
    });
    [
        "push",
        "pop",
        "shift",
        "unshift",
        "splice"
    ].forEach((key)=>{
        instrumentations[key] = function(...args) {
            $99b18dd98d1424fc$var$pauseTracking();
            const res = $99b18dd98d1424fc$var$toRaw(this)[key].apply(this, args);
            $99b18dd98d1424fc$var$resetTracking();
            return res;
        };
    });
    return instrumentations;
}
function $99b18dd98d1424fc$var$createGetter(isReadonly = false, shallow = false) {
    return function get3(target, key, receiver) {
        if (key === "__v_isReactive") return !isReadonly;
        else if (key === "__v_isReadonly") return isReadonly;
        else if (key === "__v_raw" && receiver === (isReadonly ? shallow ? $99b18dd98d1424fc$var$shallowReadonlyMap : $99b18dd98d1424fc$var$readonlyMap : shallow ? $99b18dd98d1424fc$var$shallowReactiveMap : $99b18dd98d1424fc$var$reactiveMap).get(target)) return target;
        const targetIsArray = $99b18dd98d1424fc$var$isArray(target);
        if (!isReadonly && targetIsArray && $99b18dd98d1424fc$var$hasOwn($99b18dd98d1424fc$var$arrayInstrumentations, key)) return Reflect.get($99b18dd98d1424fc$var$arrayInstrumentations, key, receiver);
        const res = Reflect.get(target, key, receiver);
        if ($99b18dd98d1424fc$var$isSymbol(key) ? $99b18dd98d1424fc$var$builtInSymbols.has(key) : $99b18dd98d1424fc$var$isNonTrackableKeys(key)) return res;
        if (!isReadonly) $99b18dd98d1424fc$var$track(target, "get", key);
        if (shallow) return res;
        if ($99b18dd98d1424fc$var$isRef(res)) {
            const shouldUnwrap = !targetIsArray || !$99b18dd98d1424fc$var$isIntegerKey(key);
            return shouldUnwrap ? res.value : res;
        }
        if ($99b18dd98d1424fc$var$isObject(res)) return isReadonly ? $99b18dd98d1424fc$var$readonly(res) : $99b18dd98d1424fc$var$reactive2(res);
        return res;
    };
}
var $99b18dd98d1424fc$var$set2 = /* @__PURE__ */ $99b18dd98d1424fc$var$createSetter();
function $99b18dd98d1424fc$var$createSetter(shallow = false) {
    return function set3(target, key, value, receiver) {
        let oldValue = target[key];
        if (!shallow) {
            value = $99b18dd98d1424fc$var$toRaw(value);
            oldValue = $99b18dd98d1424fc$var$toRaw(oldValue);
            if (!$99b18dd98d1424fc$var$isArray(target) && $99b18dd98d1424fc$var$isRef(oldValue) && !$99b18dd98d1424fc$var$isRef(value)) {
                oldValue.value = value;
                return true;
            }
        }
        const hadKey = $99b18dd98d1424fc$var$isArray(target) && $99b18dd98d1424fc$var$isIntegerKey(key) ? Number(key) < target.length : $99b18dd98d1424fc$var$hasOwn(target, key);
        const result = Reflect.set(target, key, value, receiver);
        if (target === $99b18dd98d1424fc$var$toRaw(receiver)) {
            if (!hadKey) $99b18dd98d1424fc$var$trigger(target, "add", key, value);
            else if ($99b18dd98d1424fc$var$hasChanged(value, oldValue)) $99b18dd98d1424fc$var$trigger(target, "set", key, value, oldValue);
        }
        return result;
    };
}
function $99b18dd98d1424fc$var$deleteProperty(target, key) {
    const hadKey = $99b18dd98d1424fc$var$hasOwn(target, key);
    const oldValue = target[key];
    const result = Reflect.deleteProperty(target, key);
    if (result && hadKey) $99b18dd98d1424fc$var$trigger(target, "delete", key, void 0, oldValue);
    return result;
}
function $99b18dd98d1424fc$var$has(target, key) {
    const result = Reflect.has(target, key);
    if (!$99b18dd98d1424fc$var$isSymbol(key) || !$99b18dd98d1424fc$var$builtInSymbols.has(key)) $99b18dd98d1424fc$var$track(target, "has", key);
    return result;
}
function $99b18dd98d1424fc$var$ownKeys(target) {
    $99b18dd98d1424fc$var$track(target, "iterate", $99b18dd98d1424fc$var$isArray(target) ? "length" : $99b18dd98d1424fc$var$ITERATE_KEY);
    return Reflect.ownKeys(target);
}
var $99b18dd98d1424fc$var$mutableHandlers = {
    get: $99b18dd98d1424fc$var$get2,
    set: $99b18dd98d1424fc$var$set2,
    deleteProperty: $99b18dd98d1424fc$var$deleteProperty,
    has: $99b18dd98d1424fc$var$has,
    ownKeys: $99b18dd98d1424fc$var$ownKeys
};
var $99b18dd98d1424fc$var$readonlyHandlers = {
    get: $99b18dd98d1424fc$var$readonlyGet,
    set (target, key) {
        console.warn(`Set operation on key "${String(key)}" failed: target is readonly.`, target);
        return true;
    },
    deleteProperty (target, key) {
        console.warn(`Delete operation on key "${String(key)}" failed: target is readonly.`, target);
        return true;
    }
};
var $99b18dd98d1424fc$var$toReactive = (value)=>$99b18dd98d1424fc$var$isObject(value) ? $99b18dd98d1424fc$var$reactive2(value) : value;
var $99b18dd98d1424fc$var$toReadonly = (value)=>$99b18dd98d1424fc$var$isObject(value) ? $99b18dd98d1424fc$var$readonly(value) : value;
var $99b18dd98d1424fc$var$toShallow = (value)=>value;
var $99b18dd98d1424fc$var$getProto = (v)=>Reflect.getPrototypeOf(v);
function $99b18dd98d1424fc$var$get$1(target, key, isReadonly = false, isShallow = false) {
    target = target["__v_raw"];
    const rawTarget = $99b18dd98d1424fc$var$toRaw(target);
    const rawKey = $99b18dd98d1424fc$var$toRaw(key);
    if (key !== rawKey) !isReadonly && $99b18dd98d1424fc$var$track(rawTarget, "get", key);
    !isReadonly && $99b18dd98d1424fc$var$track(rawTarget, "get", rawKey);
    const { has: has2 } = $99b18dd98d1424fc$var$getProto(rawTarget);
    const wrap = isShallow ? $99b18dd98d1424fc$var$toShallow : isReadonly ? $99b18dd98d1424fc$var$toReadonly : $99b18dd98d1424fc$var$toReactive;
    if (has2.call(rawTarget, key)) return wrap(target.get(key));
    else if (has2.call(rawTarget, rawKey)) return wrap(target.get(rawKey));
    else if (target !== rawTarget) target.get(key);
}
function $99b18dd98d1424fc$var$has$1(key, isReadonly = false) {
    const target = this["__v_raw"];
    const rawTarget = $99b18dd98d1424fc$var$toRaw(target);
    const rawKey = $99b18dd98d1424fc$var$toRaw(key);
    if (key !== rawKey) !isReadonly && $99b18dd98d1424fc$var$track(rawTarget, "has", key);
    !isReadonly && $99b18dd98d1424fc$var$track(rawTarget, "has", rawKey);
    return key === rawKey ? target.has(key) : target.has(key) || target.has(rawKey);
}
function $99b18dd98d1424fc$var$size(target, isReadonly = false) {
    target = target["__v_raw"];
    !isReadonly && $99b18dd98d1424fc$var$track($99b18dd98d1424fc$var$toRaw(target), "iterate", $99b18dd98d1424fc$var$ITERATE_KEY);
    return Reflect.get(target, "size", target);
}
function $99b18dd98d1424fc$var$add(value) {
    value = $99b18dd98d1424fc$var$toRaw(value);
    const target = $99b18dd98d1424fc$var$toRaw(this);
    const proto = $99b18dd98d1424fc$var$getProto(target);
    const hadKey = proto.has.call(target, value);
    if (!hadKey) {
        target.add(value);
        $99b18dd98d1424fc$var$trigger(target, "add", value, value);
    }
    return this;
}
function $99b18dd98d1424fc$var$set$1(key, value) {
    value = $99b18dd98d1424fc$var$toRaw(value);
    const target = $99b18dd98d1424fc$var$toRaw(this);
    const { has: has2, get: get3 } = $99b18dd98d1424fc$var$getProto(target);
    let hadKey = has2.call(target, key);
    if (!hadKey) {
        key = $99b18dd98d1424fc$var$toRaw(key);
        hadKey = has2.call(target, key);
    } else $99b18dd98d1424fc$var$checkIdentityKeys(target, has2, key);
    const oldValue = get3.call(target, key);
    target.set(key, value);
    if (!hadKey) $99b18dd98d1424fc$var$trigger(target, "add", key, value);
    else if ($99b18dd98d1424fc$var$hasChanged(value, oldValue)) $99b18dd98d1424fc$var$trigger(target, "set", key, value, oldValue);
    return this;
}
function $99b18dd98d1424fc$var$deleteEntry(key) {
    const target = $99b18dd98d1424fc$var$toRaw(this);
    const { has: has2, get: get3 } = $99b18dd98d1424fc$var$getProto(target);
    let hadKey = has2.call(target, key);
    if (!hadKey) {
        key = $99b18dd98d1424fc$var$toRaw(key);
        hadKey = has2.call(target, key);
    } else $99b18dd98d1424fc$var$checkIdentityKeys(target, has2, key);
    const oldValue = get3 ? get3.call(target, key) : void 0;
    const result = target.delete(key);
    if (hadKey) $99b18dd98d1424fc$var$trigger(target, "delete", key, void 0, oldValue);
    return result;
}
function $99b18dd98d1424fc$var$clear() {
    const target = $99b18dd98d1424fc$var$toRaw(this);
    const hadItems = target.size !== 0;
    const oldTarget = $99b18dd98d1424fc$var$isMap(target) ? new Map(target) : new Set(target);
    const result = target.clear();
    if (hadItems) $99b18dd98d1424fc$var$trigger(target, "clear", void 0, void 0, oldTarget);
    return result;
}
function $99b18dd98d1424fc$var$createForEach(isReadonly, isShallow) {
    return function forEach(callback, thisArg) {
        const observed = this;
        const target = observed["__v_raw"];
        const rawTarget = $99b18dd98d1424fc$var$toRaw(target);
        const wrap = isShallow ? $99b18dd98d1424fc$var$toShallow : isReadonly ? $99b18dd98d1424fc$var$toReadonly : $99b18dd98d1424fc$var$toReactive;
        !isReadonly && $99b18dd98d1424fc$var$track(rawTarget, "iterate", $99b18dd98d1424fc$var$ITERATE_KEY);
        return target.forEach((value, key)=>{
            return callback.call(thisArg, wrap(value), wrap(key), observed);
        });
    };
}
function $99b18dd98d1424fc$var$createIterableMethod(method, isReadonly, isShallow) {
    return function(...args) {
        const target = this["__v_raw"];
        const rawTarget = $99b18dd98d1424fc$var$toRaw(target);
        const targetIsMap = $99b18dd98d1424fc$var$isMap(rawTarget);
        const isPair = method === "entries" || method === Symbol.iterator && targetIsMap;
        const isKeyOnly = method === "keys" && targetIsMap;
        const innerIterator = target[method](...args);
        const wrap = isShallow ? $99b18dd98d1424fc$var$toShallow : isReadonly ? $99b18dd98d1424fc$var$toReadonly : $99b18dd98d1424fc$var$toReactive;
        !isReadonly && $99b18dd98d1424fc$var$track(rawTarget, "iterate", isKeyOnly ? $99b18dd98d1424fc$var$MAP_KEY_ITERATE_KEY : $99b18dd98d1424fc$var$ITERATE_KEY);
        return {
            // iterator protocol
            next () {
                const { value: value, done: done } = innerIterator.next();
                return done ? {
                    value: value,
                    done: done
                } : {
                    value: isPair ? [
                        wrap(value[0]),
                        wrap(value[1])
                    ] : wrap(value),
                    done: done
                };
            },
            // iterable protocol
            [Symbol.iterator] () {
                return this;
            }
        };
    };
}
function $99b18dd98d1424fc$var$createReadonlyMethod(type) {
    return function(...args) {
        {
            const key = args[0] ? `on key "${args[0]}" ` : ``;
            console.warn(`${$99b18dd98d1424fc$var$capitalize(type)} operation ${key}failed: target is readonly.`, $99b18dd98d1424fc$var$toRaw(this));
        }
        return type === "delete" ? false : this;
    };
}
function $99b18dd98d1424fc$var$createInstrumentations() {
    const mutableInstrumentations2 = {
        get (key) {
            return $99b18dd98d1424fc$var$get$1(this, key);
        },
        get size () {
            return $99b18dd98d1424fc$var$size(this);
        },
        has: $99b18dd98d1424fc$var$has$1,
        add: $99b18dd98d1424fc$var$add,
        set: $99b18dd98d1424fc$var$set$1,
        delete: $99b18dd98d1424fc$var$deleteEntry,
        clear: $99b18dd98d1424fc$var$clear,
        forEach: $99b18dd98d1424fc$var$createForEach(false, false)
    };
    const shallowInstrumentations2 = {
        get (key) {
            return $99b18dd98d1424fc$var$get$1(this, key, false, true);
        },
        get size () {
            return $99b18dd98d1424fc$var$size(this);
        },
        has: $99b18dd98d1424fc$var$has$1,
        add: $99b18dd98d1424fc$var$add,
        set: $99b18dd98d1424fc$var$set$1,
        delete: $99b18dd98d1424fc$var$deleteEntry,
        clear: $99b18dd98d1424fc$var$clear,
        forEach: $99b18dd98d1424fc$var$createForEach(false, true)
    };
    const readonlyInstrumentations2 = {
        get (key) {
            return $99b18dd98d1424fc$var$get$1(this, key, true);
        },
        get size () {
            return $99b18dd98d1424fc$var$size(this, true);
        },
        has (key) {
            return $99b18dd98d1424fc$var$has$1.call(this, key, true);
        },
        add: $99b18dd98d1424fc$var$createReadonlyMethod("add"),
        set: $99b18dd98d1424fc$var$createReadonlyMethod("set"),
        delete: $99b18dd98d1424fc$var$createReadonlyMethod("delete"),
        clear: $99b18dd98d1424fc$var$createReadonlyMethod("clear"),
        forEach: $99b18dd98d1424fc$var$createForEach(true, false)
    };
    const shallowReadonlyInstrumentations2 = {
        get (key) {
            return $99b18dd98d1424fc$var$get$1(this, key, true, true);
        },
        get size () {
            return $99b18dd98d1424fc$var$size(this, true);
        },
        has (key) {
            return $99b18dd98d1424fc$var$has$1.call(this, key, true);
        },
        add: $99b18dd98d1424fc$var$createReadonlyMethod("add"),
        set: $99b18dd98d1424fc$var$createReadonlyMethod("set"),
        delete: $99b18dd98d1424fc$var$createReadonlyMethod("delete"),
        clear: $99b18dd98d1424fc$var$createReadonlyMethod("clear"),
        forEach: $99b18dd98d1424fc$var$createForEach(true, true)
    };
    const iteratorMethods = [
        "keys",
        "values",
        "entries",
        Symbol.iterator
    ];
    iteratorMethods.forEach((method)=>{
        mutableInstrumentations2[method] = $99b18dd98d1424fc$var$createIterableMethod(method, false, false);
        readonlyInstrumentations2[method] = $99b18dd98d1424fc$var$createIterableMethod(method, true, false);
        shallowInstrumentations2[method] = $99b18dd98d1424fc$var$createIterableMethod(method, false, true);
        shallowReadonlyInstrumentations2[method] = $99b18dd98d1424fc$var$createIterableMethod(method, true, true);
    });
    return [
        mutableInstrumentations2,
        readonlyInstrumentations2,
        shallowInstrumentations2,
        shallowReadonlyInstrumentations2
    ];
}
var [$99b18dd98d1424fc$var$mutableInstrumentations, $99b18dd98d1424fc$var$readonlyInstrumentations, $99b18dd98d1424fc$var$shallowInstrumentations, $99b18dd98d1424fc$var$shallowReadonlyInstrumentations] = /* @__PURE__ */ $99b18dd98d1424fc$var$createInstrumentations();
function $99b18dd98d1424fc$var$createInstrumentationGetter(isReadonly, shallow) {
    const instrumentations = shallow ? isReadonly ? $99b18dd98d1424fc$var$shallowReadonlyInstrumentations : $99b18dd98d1424fc$var$shallowInstrumentations : isReadonly ? $99b18dd98d1424fc$var$readonlyInstrumentations : $99b18dd98d1424fc$var$mutableInstrumentations;
    return (target, key, receiver)=>{
        if (key === "__v_isReactive") return !isReadonly;
        else if (key === "__v_isReadonly") return isReadonly;
        else if (key === "__v_raw") return target;
        return Reflect.get($99b18dd98d1424fc$var$hasOwn(instrumentations, key) && key in target ? instrumentations : target, key, receiver);
    };
}
var $99b18dd98d1424fc$var$mutableCollectionHandlers = {
    get: /* @__PURE__ */ $99b18dd98d1424fc$var$createInstrumentationGetter(false, false)
};
var $99b18dd98d1424fc$var$readonlyCollectionHandlers = {
    get: /* @__PURE__ */ $99b18dd98d1424fc$var$createInstrumentationGetter(true, false)
};
function $99b18dd98d1424fc$var$checkIdentityKeys(target, has2, key) {
    const rawKey = $99b18dd98d1424fc$var$toRaw(key);
    if (rawKey !== key && has2.call(target, rawKey)) {
        const type = $99b18dd98d1424fc$var$toRawType(target);
        console.warn(`Reactive ${type} contains both the raw and reactive versions of the same object${type === `Map` ? ` as keys` : ``}, which can lead to inconsistencies. Avoid differentiating between the raw and reactive versions of an object and only use the reactive version if possible.`);
    }
}
var $99b18dd98d1424fc$var$reactiveMap = /* @__PURE__ */ new WeakMap();
var $99b18dd98d1424fc$var$shallowReactiveMap = /* @__PURE__ */ new WeakMap();
var $99b18dd98d1424fc$var$readonlyMap = /* @__PURE__ */ new WeakMap();
var $99b18dd98d1424fc$var$shallowReadonlyMap = /* @__PURE__ */ new WeakMap();
function $99b18dd98d1424fc$var$targetTypeMap(rawType) {
    switch(rawType){
        case "Object":
        case "Array":
            return 1;
        case "Map":
        case "Set":
        case "WeakMap":
        case "WeakSet":
            return 2;
        default:
            return 0;
    }
}
function $99b18dd98d1424fc$var$getTargetType(value) {
    return value["__v_skip"] || !Object.isExtensible(value) ? 0 : $99b18dd98d1424fc$var$targetTypeMap($99b18dd98d1424fc$var$toRawType(value));
}
function $99b18dd98d1424fc$var$reactive2(target) {
    if (target && target["__v_isReadonly"]) return target;
    return $99b18dd98d1424fc$var$createReactiveObject(target, false, $99b18dd98d1424fc$var$mutableHandlers, $99b18dd98d1424fc$var$mutableCollectionHandlers, $99b18dd98d1424fc$var$reactiveMap);
}
function $99b18dd98d1424fc$var$readonly(target) {
    return $99b18dd98d1424fc$var$createReactiveObject(target, true, $99b18dd98d1424fc$var$readonlyHandlers, $99b18dd98d1424fc$var$readonlyCollectionHandlers, $99b18dd98d1424fc$var$readonlyMap);
}
function $99b18dd98d1424fc$var$createReactiveObject(target, isReadonly, baseHandlers, collectionHandlers, proxyMap) {
    if (!$99b18dd98d1424fc$var$isObject(target)) {
        console.warn(`value cannot be made reactive: ${String(target)}`);
        return target;
    }
    if (target["__v_raw"] && !(isReadonly && target["__v_isReactive"])) return target;
    const existingProxy = proxyMap.get(target);
    if (existingProxy) return existingProxy;
    const targetType = $99b18dd98d1424fc$var$getTargetType(target);
    if (targetType === 0) return target;
    const proxy = new Proxy(target, targetType === 2 ? collectionHandlers : baseHandlers);
    proxyMap.set(target, proxy);
    return proxy;
}
function $99b18dd98d1424fc$var$toRaw(observed) {
    return observed && $99b18dd98d1424fc$var$toRaw(observed["__v_raw"]) || observed;
}
function $99b18dd98d1424fc$var$isRef(r) {
    return Boolean(r && r.__v_isRef === true);
}
// packages/alpinejs/src/magics/$nextTick.js
$99b18dd98d1424fc$var$magic("nextTick", ()=>$99b18dd98d1424fc$var$nextTick);
// packages/alpinejs/src/magics/$dispatch.js
$99b18dd98d1424fc$var$magic("dispatch", (el)=>$99b18dd98d1424fc$var$dispatch.bind($99b18dd98d1424fc$var$dispatch, el));
// packages/alpinejs/src/magics/$watch.js
$99b18dd98d1424fc$var$magic("watch", (el, { evaluateLater: evaluateLater2, cleanup: cleanup2 })=>(key, callback)=>{
        let evaluate2 = evaluateLater2(key);
        let getter = ()=>{
            let value;
            evaluate2((i)=>value = i);
            return value;
        };
        let unwatch = $99b18dd98d1424fc$var$watch(getter, callback);
        cleanup2(unwatch);
    });
// packages/alpinejs/src/magics/$store.js
$99b18dd98d1424fc$var$magic("store", $99b18dd98d1424fc$var$getStores);
// packages/alpinejs/src/magics/$data.js
$99b18dd98d1424fc$var$magic("data", (el)=>$99b18dd98d1424fc$var$scope(el));
// packages/alpinejs/src/magics/$root.js
$99b18dd98d1424fc$var$magic("root", (el)=>$99b18dd98d1424fc$var$closestRoot(el));
// packages/alpinejs/src/magics/$refs.js
$99b18dd98d1424fc$var$magic("refs", (el)=>{
    if (el._x_refs_proxy) return el._x_refs_proxy;
    el._x_refs_proxy = $99b18dd98d1424fc$var$mergeProxies($99b18dd98d1424fc$var$getArrayOfRefObject(el));
    return el._x_refs_proxy;
});
function $99b18dd98d1424fc$var$getArrayOfRefObject(el) {
    let refObjects = [];
    $99b18dd98d1424fc$var$findClosest(el, (i)=>{
        if (i._x_refs) refObjects.push(i._x_refs);
    });
    return refObjects;
}
// packages/alpinejs/src/ids.js
var $99b18dd98d1424fc$var$globalIdMemo = {};
function $99b18dd98d1424fc$var$findAndIncrementId(name) {
    if (!$99b18dd98d1424fc$var$globalIdMemo[name]) $99b18dd98d1424fc$var$globalIdMemo[name] = 0;
    return ++$99b18dd98d1424fc$var$globalIdMemo[name];
}
function $99b18dd98d1424fc$var$closestIdRoot(el, name) {
    return $99b18dd98d1424fc$var$findClosest(el, (element)=>{
        if (element._x_ids && element._x_ids[name]) return true;
    });
}
function $99b18dd98d1424fc$var$setIdRoot(el, name) {
    if (!el._x_ids) el._x_ids = {};
    if (!el._x_ids[name]) el._x_ids[name] = $99b18dd98d1424fc$var$findAndIncrementId(name);
}
// packages/alpinejs/src/magics/$id.js
$99b18dd98d1424fc$var$magic("id", (el, { cleanup: cleanup2 })=>(name, key = null)=>{
        let cacheKey = `${name}${key ? `-${key}` : ""}`;
        return $99b18dd98d1424fc$var$cacheIdByNameOnElement(el, cacheKey, cleanup2, ()=>{
            let root = $99b18dd98d1424fc$var$closestIdRoot(el, name);
            let id = root ? root._x_ids[name] : $99b18dd98d1424fc$var$findAndIncrementId(name);
            return key ? `${name}-${id}-${key}` : `${name}-${id}`;
        });
    });
$99b18dd98d1424fc$var$interceptClone((from, to)=>{
    if (from._x_id) to._x_id = from._x_id;
});
function $99b18dd98d1424fc$var$cacheIdByNameOnElement(el, cacheKey, cleanup2, callback) {
    if (!el._x_id) el._x_id = {};
    if (el._x_id[cacheKey]) return el._x_id[cacheKey];
    let output = callback();
    el._x_id[cacheKey] = output;
    cleanup2(()=>{
        delete el._x_id[cacheKey];
    });
    return output;
}
// packages/alpinejs/src/magics/$el.js
$99b18dd98d1424fc$var$magic("el", (el)=>el);
// packages/alpinejs/src/magics/index.js
$99b18dd98d1424fc$var$warnMissingPluginMagic("Focus", "focus", "focus");
$99b18dd98d1424fc$var$warnMissingPluginMagic("Persist", "persist", "persist");
function $99b18dd98d1424fc$var$warnMissingPluginMagic(name, magicName, slug) {
    $99b18dd98d1424fc$var$magic(magicName, (el)=>$99b18dd98d1424fc$var$warn(`You can't use [$${magicName}] without first installing the "${name}" plugin here: https://alpinejs.dev/plugins/${slug}`, el));
}
// packages/alpinejs/src/directives/x-modelable.js
$99b18dd98d1424fc$var$directive("modelable", (el, { expression: expression }, { effect: effect3, evaluateLater: evaluateLater2, cleanup: cleanup2 })=>{
    let func = evaluateLater2(expression);
    let innerGet = ()=>{
        let result;
        func((i)=>result = i);
        return result;
    };
    let evaluateInnerSet = evaluateLater2(`${expression} = __placeholder`);
    let innerSet = (val)=>evaluateInnerSet(()=>{}, {
            scope: {
                "__placeholder": val
            }
        });
    let initialValue = innerGet();
    innerSet(initialValue);
    queueMicrotask(()=>{
        if (!el._x_model) return;
        el._x_removeModelListeners["default"]();
        let outerGet = el._x_model.get;
        let outerSet = el._x_model.set;
        let releaseEntanglement = $99b18dd98d1424fc$var$entangle({
            get () {
                return outerGet();
            },
            set (value) {
                outerSet(value);
            }
        }, {
            get () {
                return innerGet();
            },
            set (value) {
                innerSet(value);
            }
        });
        cleanup2(releaseEntanglement);
    });
});
// packages/alpinejs/src/directives/x-teleport.js
$99b18dd98d1424fc$var$directive("teleport", (el, { modifiers: modifiers, expression: expression }, { cleanup: cleanup2 })=>{
    if (el.tagName.toLowerCase() !== "template") $99b18dd98d1424fc$var$warn("x-teleport can only be used on a <template> tag", el);
    let target = $99b18dd98d1424fc$var$getTarget(expression);
    let clone2 = el.content.cloneNode(true).firstElementChild;
    el._x_teleport = clone2;
    clone2._x_teleportBack = el;
    el.setAttribute("data-teleport-template", true);
    clone2.setAttribute("data-teleport-target", true);
    if (el._x_forwardEvents) el._x_forwardEvents.forEach((eventName)=>{
        clone2.addEventListener(eventName, (e)=>{
            e.stopPropagation();
            el.dispatchEvent(new e.constructor(e.type, e));
        });
    });
    $99b18dd98d1424fc$var$addScopeToNode(clone2, {}, el);
    let placeInDom = (clone3, target2, modifiers2)=>{
        if (modifiers2.includes("prepend")) target2.parentNode.insertBefore(clone3, target2);
        else if (modifiers2.includes("append")) target2.parentNode.insertBefore(clone3, target2.nextSibling);
        else target2.appendChild(clone3);
    };
    $99b18dd98d1424fc$var$mutateDom(()=>{
        placeInDom(clone2, target, modifiers);
        $99b18dd98d1424fc$var$skipDuringClone(()=>{
            $99b18dd98d1424fc$var$initTree(clone2);
        })();
    });
    el._x_teleportPutBack = ()=>{
        let target2 = $99b18dd98d1424fc$var$getTarget(expression);
        $99b18dd98d1424fc$var$mutateDom(()=>{
            placeInDom(el._x_teleport, target2, modifiers);
        });
    };
    cleanup2(()=>$99b18dd98d1424fc$var$mutateDom(()=>{
            clone2.remove();
            $99b18dd98d1424fc$var$destroyTree(clone2);
        }));
});
var $99b18dd98d1424fc$var$teleportContainerDuringClone = document.createElement("div");
function $99b18dd98d1424fc$var$getTarget(expression) {
    let target = $99b18dd98d1424fc$var$skipDuringClone(()=>{
        return document.querySelector(expression);
    }, ()=>{
        return $99b18dd98d1424fc$var$teleportContainerDuringClone;
    })();
    if (!target) $99b18dd98d1424fc$var$warn(`Cannot find x-teleport element for selector: "${expression}"`);
    return target;
}
// packages/alpinejs/src/directives/x-ignore.js
var $99b18dd98d1424fc$var$handler = ()=>{};
$99b18dd98d1424fc$var$handler.inline = (el, { modifiers: modifiers }, { cleanup: cleanup2 })=>{
    modifiers.includes("self") ? el._x_ignoreSelf = true : el._x_ignore = true;
    cleanup2(()=>{
        modifiers.includes("self") ? delete el._x_ignoreSelf : delete el._x_ignore;
    });
};
$99b18dd98d1424fc$var$directive("ignore", $99b18dd98d1424fc$var$handler);
// packages/alpinejs/src/directives/x-effect.js
$99b18dd98d1424fc$var$directive("effect", $99b18dd98d1424fc$var$skipDuringClone((el, { expression: expression }, { effect: effect3 })=>{
    effect3($99b18dd98d1424fc$var$evaluateLater(el, expression));
}));
// packages/alpinejs/src/utils/on.js
function $99b18dd98d1424fc$var$on(el, event, modifiers, callback) {
    let listenerTarget = el;
    let handler4 = (e)=>callback(e);
    let options = {};
    let wrapHandler = (callback2, wrapper)=>(e)=>wrapper(callback2, e);
    if (modifiers.includes("dot")) event = $99b18dd98d1424fc$var$dotSyntax(event);
    if (modifiers.includes("camel")) event = $99b18dd98d1424fc$var$camelCase2(event);
    if (modifiers.includes("passive")) options.passive = true;
    if (modifiers.includes("capture")) options.capture = true;
    if (modifiers.includes("window")) listenerTarget = window;
    if (modifiers.includes("document")) listenerTarget = document;
    if (modifiers.includes("debounce")) {
        let nextModifier = modifiers[modifiers.indexOf("debounce") + 1] || "invalid-wait";
        let wait = $99b18dd98d1424fc$var$isNumeric(nextModifier.split("ms")[0]) ? Number(nextModifier.split("ms")[0]) : 250;
        handler4 = $99b18dd98d1424fc$var$debounce(handler4, wait);
    }
    if (modifiers.includes("throttle")) {
        let nextModifier = modifiers[modifiers.indexOf("throttle") + 1] || "invalid-wait";
        let wait = $99b18dd98d1424fc$var$isNumeric(nextModifier.split("ms")[0]) ? Number(nextModifier.split("ms")[0]) : 250;
        handler4 = $99b18dd98d1424fc$var$throttle(handler4, wait);
    }
    if (modifiers.includes("prevent")) handler4 = wrapHandler(handler4, (next, e)=>{
        e.preventDefault();
        next(e);
    });
    if (modifiers.includes("stop")) handler4 = wrapHandler(handler4, (next, e)=>{
        e.stopPropagation();
        next(e);
    });
    if (modifiers.includes("once")) handler4 = wrapHandler(handler4, (next, e)=>{
        next(e);
        listenerTarget.removeEventListener(event, handler4, options);
    });
    if (modifiers.includes("away") || modifiers.includes("outside")) {
        listenerTarget = document;
        handler4 = wrapHandler(handler4, (next, e)=>{
            if (el.contains(e.target)) return;
            if (e.target.isConnected === false) return;
            if (el.offsetWidth < 1 && el.offsetHeight < 1) return;
            if (el._x_isShown === false) return;
            next(e);
        });
    }
    if (modifiers.includes("self")) handler4 = wrapHandler(handler4, (next, e)=>{
        e.target === el && next(e);
    });
    if ($99b18dd98d1424fc$var$isKeyEvent(event) || $99b18dd98d1424fc$var$isClickEvent(event)) handler4 = wrapHandler(handler4, (next, e)=>{
        if ($99b18dd98d1424fc$var$isListeningForASpecificKeyThatHasntBeenPressed(e, modifiers)) return;
        next(e);
    });
    listenerTarget.addEventListener(event, handler4, options);
    return ()=>{
        listenerTarget.removeEventListener(event, handler4, options);
    };
}
function $99b18dd98d1424fc$var$dotSyntax(subject) {
    return subject.replace(/-/g, ".");
}
function $99b18dd98d1424fc$var$camelCase2(subject) {
    return subject.toLowerCase().replace(/-(\w)/g, (match, char)=>char.toUpperCase());
}
function $99b18dd98d1424fc$var$isNumeric(subject) {
    return !Array.isArray(subject) && !isNaN(subject);
}
function $99b18dd98d1424fc$var$kebabCase2(subject) {
    if ([
        " ",
        "_"
    ].includes(subject)) return subject;
    return subject.replace(/([a-z])([A-Z])/g, "$1-$2").replace(/[_\s]/, "-").toLowerCase();
}
function $99b18dd98d1424fc$var$isKeyEvent(event) {
    return [
        "keydown",
        "keyup"
    ].includes(event);
}
function $99b18dd98d1424fc$var$isClickEvent(event) {
    return [
        "contextmenu",
        "click",
        "mouse"
    ].some((i)=>event.includes(i));
}
function $99b18dd98d1424fc$var$isListeningForASpecificKeyThatHasntBeenPressed(e, modifiers) {
    let keyModifiers = modifiers.filter((i)=>{
        return ![
            "window",
            "document",
            "prevent",
            "stop",
            "once",
            "capture",
            "self",
            "away",
            "outside",
            "passive"
        ].includes(i);
    });
    if (keyModifiers.includes("debounce")) {
        let debounceIndex = keyModifiers.indexOf("debounce");
        keyModifiers.splice(debounceIndex, $99b18dd98d1424fc$var$isNumeric((keyModifiers[debounceIndex + 1] || "invalid-wait").split("ms")[0]) ? 2 : 1);
    }
    if (keyModifiers.includes("throttle")) {
        let debounceIndex = keyModifiers.indexOf("throttle");
        keyModifiers.splice(debounceIndex, $99b18dd98d1424fc$var$isNumeric((keyModifiers[debounceIndex + 1] || "invalid-wait").split("ms")[0]) ? 2 : 1);
    }
    if (keyModifiers.length === 0) return false;
    if (keyModifiers.length === 1 && $99b18dd98d1424fc$var$keyToModifiers(e.key).includes(keyModifiers[0])) return false;
    const systemKeyModifiers = [
        "ctrl",
        "shift",
        "alt",
        "meta",
        "cmd",
        "super"
    ];
    const selectedSystemKeyModifiers = systemKeyModifiers.filter((modifier)=>keyModifiers.includes(modifier));
    keyModifiers = keyModifiers.filter((i)=>!selectedSystemKeyModifiers.includes(i));
    if (selectedSystemKeyModifiers.length > 0) {
        const activelyPressedKeyModifiers = selectedSystemKeyModifiers.filter((modifier)=>{
            if (modifier === "cmd" || modifier === "super") modifier = "meta";
            return e[`${modifier}Key`];
        });
        if (activelyPressedKeyModifiers.length === selectedSystemKeyModifiers.length) {
            if ($99b18dd98d1424fc$var$isClickEvent(e.type)) return false;
            if ($99b18dd98d1424fc$var$keyToModifiers(e.key).includes(keyModifiers[0])) return false;
        }
    }
    return true;
}
function $99b18dd98d1424fc$var$keyToModifiers(key) {
    if (!key) return [];
    key = $99b18dd98d1424fc$var$kebabCase2(key);
    let modifierToKeyMap = {
        "ctrl": "control",
        "slash": "/",
        "space": " ",
        "spacebar": " ",
        "cmd": "meta",
        "esc": "escape",
        "up": "arrow-up",
        "down": "arrow-down",
        "left": "arrow-left",
        "right": "arrow-right",
        "period": ".",
        "comma": ",",
        "equal": "=",
        "minus": "-",
        "underscore": "_"
    };
    modifierToKeyMap[key] = key;
    return Object.keys(modifierToKeyMap).map((modifier)=>{
        if (modifierToKeyMap[modifier] === key) return modifier;
    }).filter((modifier)=>modifier);
}
// packages/alpinejs/src/directives/x-model.js
$99b18dd98d1424fc$var$directive("model", (el, { modifiers: modifiers, expression: expression }, { effect: effect3, cleanup: cleanup2 })=>{
    let scopeTarget = el;
    if (modifiers.includes("parent")) scopeTarget = el.parentNode;
    let evaluateGet = $99b18dd98d1424fc$var$evaluateLater(scopeTarget, expression);
    let evaluateSet;
    if (typeof expression === "string") evaluateSet = $99b18dd98d1424fc$var$evaluateLater(scopeTarget, `${expression} = __placeholder`);
    else if (typeof expression === "function" && typeof expression() === "string") evaluateSet = $99b18dd98d1424fc$var$evaluateLater(scopeTarget, `${expression()} = __placeholder`);
    else evaluateSet = ()=>{};
    let getValue = ()=>{
        let result;
        evaluateGet((value)=>result = value);
        return $99b18dd98d1424fc$var$isGetterSetter(result) ? result.get() : result;
    };
    let setValue = (value)=>{
        let result;
        evaluateGet((value2)=>result = value2);
        if ($99b18dd98d1424fc$var$isGetterSetter(result)) result.set(value);
        else evaluateSet(()=>{}, {
            scope: {
                "__placeholder": value
            }
        });
    };
    if (typeof expression === "string" && el.type === "radio") $99b18dd98d1424fc$var$mutateDom(()=>{
        if (!el.hasAttribute("name")) el.setAttribute("name", expression);
    });
    var event = el.tagName.toLowerCase() === "select" || [
        "checkbox",
        "radio"
    ].includes(el.type) || modifiers.includes("lazy") ? "change" : "input";
    let removeListener = $99b18dd98d1424fc$var$isCloning ? ()=>{} : $99b18dd98d1424fc$var$on(el, event, modifiers, (e)=>{
        setValue($99b18dd98d1424fc$var$getInputValue(el, modifiers, e, getValue()));
    });
    if (modifiers.includes("fill")) {
        if ([
            void 0,
            null,
            ""
        ].includes(getValue()) || $99b18dd98d1424fc$var$isCheckbox(el) && Array.isArray(getValue()) || el.tagName.toLowerCase() === "select" && el.multiple) setValue($99b18dd98d1424fc$var$getInputValue(el, modifiers, {
            target: el
        }, getValue()));
    }
    if (!el._x_removeModelListeners) el._x_removeModelListeners = {};
    el._x_removeModelListeners["default"] = removeListener;
    cleanup2(()=>el._x_removeModelListeners["default"]());
    if (el.form) {
        let removeResetListener = $99b18dd98d1424fc$var$on(el.form, "reset", [], (e)=>{
            $99b18dd98d1424fc$var$nextTick(()=>el._x_model && el._x_model.set($99b18dd98d1424fc$var$getInputValue(el, modifiers, {
                    target: el
                }, getValue())));
        });
        cleanup2(()=>removeResetListener());
    }
    el._x_model = {
        get () {
            return getValue();
        },
        set (value) {
            setValue(value);
        }
    };
    el._x_forceModelUpdate = (value)=>{
        if (value === void 0 && typeof expression === "string" && expression.match(/\./)) value = "";
        window.fromModel = true;
        $99b18dd98d1424fc$var$mutateDom(()=>$99b18dd98d1424fc$var$bind(el, "value", value));
        delete window.fromModel;
    };
    effect3(()=>{
        let value = getValue();
        if (modifiers.includes("unintrusive") && document.activeElement.isSameNode(el)) return;
        el._x_forceModelUpdate(value);
    });
});
function $99b18dd98d1424fc$var$getInputValue(el, modifiers, event, currentValue) {
    return $99b18dd98d1424fc$var$mutateDom(()=>{
        if (event instanceof CustomEvent && event.detail !== void 0) return event.detail !== null && event.detail !== void 0 ? event.detail : event.target.value;
        else if ($99b18dd98d1424fc$var$isCheckbox(el)) {
            if (Array.isArray(currentValue)) {
                let newValue = null;
                if (modifiers.includes("number")) newValue = $99b18dd98d1424fc$var$safeParseNumber(event.target.value);
                else if (modifiers.includes("boolean")) newValue = $99b18dd98d1424fc$var$safeParseBoolean(event.target.value);
                else newValue = event.target.value;
                return event.target.checked ? currentValue.includes(newValue) ? currentValue : currentValue.concat([
                    newValue
                ]) : currentValue.filter((el2)=>!$99b18dd98d1424fc$var$checkedAttrLooseCompare2(el2, newValue));
            } else return event.target.checked;
        } else if (el.tagName.toLowerCase() === "select" && el.multiple) {
            if (modifiers.includes("number")) return Array.from(event.target.selectedOptions).map((option)=>{
                let rawValue = option.value || option.text;
                return $99b18dd98d1424fc$var$safeParseNumber(rawValue);
            });
            else if (modifiers.includes("boolean")) return Array.from(event.target.selectedOptions).map((option)=>{
                let rawValue = option.value || option.text;
                return $99b18dd98d1424fc$var$safeParseBoolean(rawValue);
            });
            return Array.from(event.target.selectedOptions).map((option)=>{
                return option.value || option.text;
            });
        } else {
            let newValue;
            if ($99b18dd98d1424fc$var$isRadio(el)) {
                if (event.target.checked) newValue = event.target.value;
                else newValue = currentValue;
            } else newValue = event.target.value;
            if (modifiers.includes("number")) return $99b18dd98d1424fc$var$safeParseNumber(newValue);
            else if (modifiers.includes("boolean")) return $99b18dd98d1424fc$var$safeParseBoolean(newValue);
            else if (modifiers.includes("trim")) return newValue.trim();
            else return newValue;
        }
    });
}
function $99b18dd98d1424fc$var$safeParseNumber(rawValue) {
    let number = rawValue ? parseFloat(rawValue) : null;
    return $99b18dd98d1424fc$var$isNumeric2(number) ? number : rawValue;
}
function $99b18dd98d1424fc$var$checkedAttrLooseCompare2(valueA, valueB) {
    return valueA == valueB;
}
function $99b18dd98d1424fc$var$isNumeric2(subject) {
    return !Array.isArray(subject) && !isNaN(subject);
}
function $99b18dd98d1424fc$var$isGetterSetter(value) {
    return value !== null && typeof value === "object" && typeof value.get === "function" && typeof value.set === "function";
}
// packages/alpinejs/src/directives/x-cloak.js
$99b18dd98d1424fc$var$directive("cloak", (el)=>queueMicrotask(()=>$99b18dd98d1424fc$var$mutateDom(()=>el.removeAttribute($99b18dd98d1424fc$var$prefix("cloak")))));
// packages/alpinejs/src/directives/x-init.js
$99b18dd98d1424fc$var$addInitSelector(()=>`[${$99b18dd98d1424fc$var$prefix("init")}]`);
$99b18dd98d1424fc$var$directive("init", $99b18dd98d1424fc$var$skipDuringClone((el, { expression: expression }, { evaluate: evaluate2 })=>{
    if (typeof expression === "string") return !!expression.trim() && evaluate2(expression, {}, false);
    return evaluate2(expression, {}, false);
}));
// packages/alpinejs/src/directives/x-text.js
$99b18dd98d1424fc$var$directive("text", (el, { expression: expression }, { effect: effect3, evaluateLater: evaluateLater2 })=>{
    let evaluate2 = evaluateLater2(expression);
    effect3(()=>{
        evaluate2((value)=>{
            $99b18dd98d1424fc$var$mutateDom(()=>{
                el.textContent = value;
            });
        });
    });
});
// packages/alpinejs/src/directives/x-html.js
$99b18dd98d1424fc$var$directive("html", (el, { expression: expression }, { effect: effect3, evaluateLater: evaluateLater2 })=>{
    let evaluate2 = evaluateLater2(expression);
    effect3(()=>{
        evaluate2((value)=>{
            $99b18dd98d1424fc$var$mutateDom(()=>{
                el.innerHTML = value;
                el._x_ignoreSelf = true;
                $99b18dd98d1424fc$var$initTree(el);
                delete el._x_ignoreSelf;
            });
        });
    });
});
// packages/alpinejs/src/directives/x-bind.js
$99b18dd98d1424fc$var$mapAttributes($99b18dd98d1424fc$var$startingWith(":", $99b18dd98d1424fc$var$into($99b18dd98d1424fc$var$prefix("bind:"))));
var $99b18dd98d1424fc$var$handler2 = (el, { value: value, modifiers: modifiers, expression: expression, original: original }, { effect: effect3, cleanup: cleanup2 })=>{
    if (!value) {
        let bindingProviders = {};
        $99b18dd98d1424fc$var$injectBindingProviders(bindingProviders);
        let getBindings = $99b18dd98d1424fc$var$evaluateLater(el, expression);
        getBindings((bindings)=>{
            $99b18dd98d1424fc$var$applyBindingsObject(el, bindings, original);
        }, {
            scope: bindingProviders
        });
        return;
    }
    if (value === "key") return $99b18dd98d1424fc$var$storeKeyForXFor(el, expression);
    if (el._x_inlineBindings && el._x_inlineBindings[value] && el._x_inlineBindings[value].extract) return;
    let evaluate2 = $99b18dd98d1424fc$var$evaluateLater(el, expression);
    effect3(()=>evaluate2((result)=>{
            if (result === void 0 && typeof expression === "string" && expression.match(/\./)) result = "";
            $99b18dd98d1424fc$var$mutateDom(()=>$99b18dd98d1424fc$var$bind(el, value, result, modifiers));
        }));
    cleanup2(()=>{
        el._x_undoAddedClasses && el._x_undoAddedClasses();
        el._x_undoAddedStyles && el._x_undoAddedStyles();
    });
};
$99b18dd98d1424fc$var$handler2.inline = (el, { value: value, modifiers: modifiers, expression: expression })=>{
    if (!value) return;
    if (!el._x_inlineBindings) el._x_inlineBindings = {};
    el._x_inlineBindings[value] = {
        expression: expression,
        extract: false
    };
};
$99b18dd98d1424fc$var$directive("bind", $99b18dd98d1424fc$var$handler2);
function $99b18dd98d1424fc$var$storeKeyForXFor(el, expression) {
    el._x_keyExpression = expression;
}
// packages/alpinejs/src/directives/x-data.js
$99b18dd98d1424fc$var$addRootSelector(()=>`[${$99b18dd98d1424fc$var$prefix("data")}]`);
$99b18dd98d1424fc$var$directive("data", (el, { expression: expression }, { cleanup: cleanup2 })=>{
    if ($99b18dd98d1424fc$var$shouldSkipRegisteringDataDuringClone(el)) return;
    expression = expression === "" ? "{}" : expression;
    let magicContext = {};
    $99b18dd98d1424fc$var$injectMagics(magicContext, el);
    let dataProviderContext = {};
    $99b18dd98d1424fc$var$injectDataProviders(dataProviderContext, magicContext);
    let data2 = $99b18dd98d1424fc$var$evaluate(el, expression, {
        scope: dataProviderContext
    });
    if (data2 === void 0 || data2 === true) data2 = {};
    $99b18dd98d1424fc$var$injectMagics(data2, el);
    let reactiveData = $99b18dd98d1424fc$var$reactive(data2);
    $99b18dd98d1424fc$var$initInterceptors(reactiveData);
    let undo = $99b18dd98d1424fc$var$addScopeToNode(el, reactiveData);
    reactiveData["init"] && $99b18dd98d1424fc$var$evaluate(el, reactiveData["init"]);
    cleanup2(()=>{
        reactiveData["destroy"] && $99b18dd98d1424fc$var$evaluate(el, reactiveData["destroy"]);
        undo();
    });
});
$99b18dd98d1424fc$var$interceptClone((from, to)=>{
    if (from._x_dataStack) {
        to._x_dataStack = from._x_dataStack;
        to.setAttribute("data-has-alpine-state", true);
    }
});
function $99b18dd98d1424fc$var$shouldSkipRegisteringDataDuringClone(el) {
    if (!$99b18dd98d1424fc$var$isCloning) return false;
    if ($99b18dd98d1424fc$var$isCloningLegacy) return true;
    return el.hasAttribute("data-has-alpine-state");
}
// packages/alpinejs/src/directives/x-show.js
$99b18dd98d1424fc$var$directive("show", (el, { modifiers: modifiers, expression: expression }, { effect: effect3 })=>{
    let evaluate2 = $99b18dd98d1424fc$var$evaluateLater(el, expression);
    if (!el._x_doHide) el._x_doHide = ()=>{
        $99b18dd98d1424fc$var$mutateDom(()=>{
            el.style.setProperty("display", "none", modifiers.includes("important") ? "important" : void 0);
        });
    };
    if (!el._x_doShow) el._x_doShow = ()=>{
        $99b18dd98d1424fc$var$mutateDom(()=>{
            if (el.style.length === 1 && el.style.display === "none") el.removeAttribute("style");
            else el.style.removeProperty("display");
        });
    };
    let hide = ()=>{
        el._x_doHide();
        el._x_isShown = false;
    };
    let show = ()=>{
        el._x_doShow();
        el._x_isShown = true;
    };
    let clickAwayCompatibleShow = ()=>setTimeout(show);
    let toggle = $99b18dd98d1424fc$var$once((value)=>value ? show() : hide(), (value)=>{
        if (typeof el._x_toggleAndCascadeWithTransitions === "function") el._x_toggleAndCascadeWithTransitions(el, value, show, hide);
        else value ? clickAwayCompatibleShow() : hide();
    });
    let oldValue;
    let firstTime = true;
    effect3(()=>evaluate2((value)=>{
            if (!firstTime && value === oldValue) return;
            if (modifiers.includes("immediate")) value ? clickAwayCompatibleShow() : hide();
            toggle(value);
            oldValue = value;
            firstTime = false;
        }));
});
// packages/alpinejs/src/directives/x-for.js
$99b18dd98d1424fc$var$directive("for", (el, { expression: expression }, { effect: effect3, cleanup: cleanup2 })=>{
    let iteratorNames = $99b18dd98d1424fc$var$parseForExpression(expression);
    let evaluateItems = $99b18dd98d1424fc$var$evaluateLater(el, iteratorNames.items);
    let evaluateKey = $99b18dd98d1424fc$var$evaluateLater(el, // the x-bind:key expression is stored for our use instead of evaluated.
    el._x_keyExpression || "index");
    el._x_prevKeys = [];
    el._x_lookup = {};
    effect3(()=>$99b18dd98d1424fc$var$loop(el, iteratorNames, evaluateItems, evaluateKey));
    cleanup2(()=>{
        Object.values(el._x_lookup).forEach((el2)=>$99b18dd98d1424fc$var$mutateDom(()=>{
                $99b18dd98d1424fc$var$destroyTree(el2);
                el2.remove();
            }));
        delete el._x_prevKeys;
        delete el._x_lookup;
    });
});
function $99b18dd98d1424fc$var$loop(el, iteratorNames, evaluateItems, evaluateKey) {
    let isObject2 = (i)=>typeof i === "object" && !Array.isArray(i);
    let templateEl = el;
    evaluateItems((items)=>{
        if ($99b18dd98d1424fc$var$isNumeric3(items) && items >= 0) items = Array.from(Array(items).keys(), (i)=>i + 1);
        if (items === void 0) items = [];
        let lookup = el._x_lookup;
        let prevKeys = el._x_prevKeys;
        let scopes = [];
        let keys = [];
        if (isObject2(items)) items = Object.entries(items).map(([key, value])=>{
            let scope2 = $99b18dd98d1424fc$var$getIterationScopeVariables(iteratorNames, value, key, items);
            evaluateKey((value2)=>{
                if (keys.includes(value2)) $99b18dd98d1424fc$var$warn("Duplicate key on x-for", el);
                keys.push(value2);
            }, {
                scope: {
                    index: key,
                    ...scope2
                }
            });
            scopes.push(scope2);
        });
        else for(let i = 0; i < items.length; i++){
            let scope2 = $99b18dd98d1424fc$var$getIterationScopeVariables(iteratorNames, items[i], i, items);
            evaluateKey((value)=>{
                if (keys.includes(value)) $99b18dd98d1424fc$var$warn("Duplicate key on x-for", el);
                keys.push(value);
            }, {
                scope: {
                    index: i,
                    ...scope2
                }
            });
            scopes.push(scope2);
        }
        let adds = [];
        let moves = [];
        let removes = [];
        let sames = [];
        for(let i = 0; i < prevKeys.length; i++){
            let key = prevKeys[i];
            if (keys.indexOf(key) === -1) removes.push(key);
        }
        prevKeys = prevKeys.filter((key)=>!removes.includes(key));
        let lastKey = "template";
        for(let i = 0; i < keys.length; i++){
            let key = keys[i];
            let prevIndex = prevKeys.indexOf(key);
            if (prevIndex === -1) {
                prevKeys.splice(i, 0, key);
                adds.push([
                    lastKey,
                    i
                ]);
            } else if (prevIndex !== i) {
                let keyInSpot = prevKeys.splice(i, 1)[0];
                let keyForSpot = prevKeys.splice(prevIndex - 1, 1)[0];
                prevKeys.splice(i, 0, keyForSpot);
                prevKeys.splice(prevIndex, 0, keyInSpot);
                moves.push([
                    keyInSpot,
                    keyForSpot
                ]);
            } else sames.push(key);
            lastKey = key;
        }
        for(let i = 0; i < removes.length; i++){
            let key = removes[i];
            if (!(key in lookup)) continue;
            $99b18dd98d1424fc$var$mutateDom(()=>{
                $99b18dd98d1424fc$var$destroyTree(lookup[key]);
                lookup[key].remove();
            });
            delete lookup[key];
        }
        for(let i = 0; i < moves.length; i++){
            let [keyInSpot, keyForSpot] = moves[i];
            let elInSpot = lookup[keyInSpot];
            let elForSpot = lookup[keyForSpot];
            let marker = document.createElement("div");
            $99b18dd98d1424fc$var$mutateDom(()=>{
                if (!elForSpot) $99b18dd98d1424fc$var$warn(`x-for ":key" is undefined or invalid`, templateEl, keyForSpot, lookup);
                elForSpot.after(marker);
                elInSpot.after(elForSpot);
                elForSpot._x_currentIfEl && elForSpot.after(elForSpot._x_currentIfEl);
                marker.before(elInSpot);
                elInSpot._x_currentIfEl && elInSpot.after(elInSpot._x_currentIfEl);
                marker.remove();
            });
            elForSpot._x_refreshXForScope(scopes[keys.indexOf(keyForSpot)]);
        }
        for(let i = 0; i < adds.length; i++){
            let [lastKey2, index] = adds[i];
            let lastEl = lastKey2 === "template" ? templateEl : lookup[lastKey2];
            if (lastEl._x_currentIfEl) lastEl = lastEl._x_currentIfEl;
            let scope2 = scopes[index];
            let key = keys[index];
            let clone2 = document.importNode(templateEl.content, true).firstElementChild;
            let reactiveScope = $99b18dd98d1424fc$var$reactive(scope2);
            $99b18dd98d1424fc$var$addScopeToNode(clone2, reactiveScope, templateEl);
            clone2._x_refreshXForScope = (newScope)=>{
                Object.entries(newScope).forEach(([key2, value])=>{
                    reactiveScope[key2] = value;
                });
            };
            $99b18dd98d1424fc$var$mutateDom(()=>{
                lastEl.after(clone2);
                $99b18dd98d1424fc$var$skipDuringClone(()=>$99b18dd98d1424fc$var$initTree(clone2))();
            });
            if (typeof key === "object") $99b18dd98d1424fc$var$warn("x-for key cannot be an object, it must be a string or an integer", templateEl);
            lookup[key] = clone2;
        }
        for(let i = 0; i < sames.length; i++)lookup[sames[i]]._x_refreshXForScope(scopes[keys.indexOf(sames[i])]);
        templateEl._x_prevKeys = keys;
    });
}
function $99b18dd98d1424fc$var$parseForExpression(expression) {
    let forIteratorRE = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/;
    let stripParensRE = /^\s*\(|\)\s*$/g;
    let forAliasRE = /([\s\S]*?)\s+(?:in|of)\s+([\s\S]*)/;
    let inMatch = expression.match(forAliasRE);
    if (!inMatch) return;
    let res = {};
    res.items = inMatch[2].trim();
    let item = inMatch[1].replace(stripParensRE, "").trim();
    let iteratorMatch = item.match(forIteratorRE);
    if (iteratorMatch) {
        res.item = item.replace(forIteratorRE, "").trim();
        res.index = iteratorMatch[1].trim();
        if (iteratorMatch[2]) res.collection = iteratorMatch[2].trim();
    } else res.item = item;
    return res;
}
function $99b18dd98d1424fc$var$getIterationScopeVariables(iteratorNames, item, index, items) {
    let scopeVariables = {};
    if (/^\[.*\]$/.test(iteratorNames.item) && Array.isArray(item)) {
        let names = iteratorNames.item.replace("[", "").replace("]", "").split(",").map((i)=>i.trim());
        names.forEach((name, i)=>{
            scopeVariables[name] = item[i];
        });
    } else if (/^\{.*\}$/.test(iteratorNames.item) && !Array.isArray(item) && typeof item === "object") {
        let names = iteratorNames.item.replace("{", "").replace("}", "").split(",").map((i)=>i.trim());
        names.forEach((name)=>{
            scopeVariables[name] = item[name];
        });
    } else scopeVariables[iteratorNames.item] = item;
    if (iteratorNames.index) scopeVariables[iteratorNames.index] = index;
    if (iteratorNames.collection) scopeVariables[iteratorNames.collection] = items;
    return scopeVariables;
}
function $99b18dd98d1424fc$var$isNumeric3(subject) {
    return !Array.isArray(subject) && !isNaN(subject);
}
// packages/alpinejs/src/directives/x-ref.js
function $99b18dd98d1424fc$var$handler3() {}
$99b18dd98d1424fc$var$handler3.inline = (el, { expression: expression }, { cleanup: cleanup2 })=>{
    let root = $99b18dd98d1424fc$var$closestRoot(el);
    if (!root._x_refs) root._x_refs = {};
    root._x_refs[expression] = el;
    cleanup2(()=>delete root._x_refs[expression]);
};
$99b18dd98d1424fc$var$directive("ref", $99b18dd98d1424fc$var$handler3);
// packages/alpinejs/src/directives/x-if.js
$99b18dd98d1424fc$var$directive("if", (el, { expression: expression }, { effect: effect3, cleanup: cleanup2 })=>{
    if (el.tagName.toLowerCase() !== "template") $99b18dd98d1424fc$var$warn("x-if can only be used on a <template> tag", el);
    let evaluate2 = $99b18dd98d1424fc$var$evaluateLater(el, expression);
    let show = ()=>{
        if (el._x_currentIfEl) return el._x_currentIfEl;
        let clone2 = el.content.cloneNode(true).firstElementChild;
        $99b18dd98d1424fc$var$addScopeToNode(clone2, {}, el);
        $99b18dd98d1424fc$var$mutateDom(()=>{
            el.after(clone2);
            $99b18dd98d1424fc$var$skipDuringClone(()=>$99b18dd98d1424fc$var$initTree(clone2))();
        });
        el._x_currentIfEl = clone2;
        el._x_undoIf = ()=>{
            $99b18dd98d1424fc$var$mutateDom(()=>{
                $99b18dd98d1424fc$var$destroyTree(clone2);
                clone2.remove();
            });
            delete el._x_currentIfEl;
        };
        return clone2;
    };
    let hide = ()=>{
        if (!el._x_undoIf) return;
        el._x_undoIf();
        delete el._x_undoIf;
    };
    effect3(()=>evaluate2((value)=>{
            value ? show() : hide();
        }));
    cleanup2(()=>el._x_undoIf && el._x_undoIf());
});
// packages/alpinejs/src/directives/x-id.js
$99b18dd98d1424fc$var$directive("id", (el, { expression: expression }, { evaluate: evaluate2 })=>{
    let names = evaluate2(expression);
    names.forEach((name)=>$99b18dd98d1424fc$var$setIdRoot(el, name));
});
$99b18dd98d1424fc$var$interceptClone((from, to)=>{
    if (from._x_ids) to._x_ids = from._x_ids;
});
// packages/alpinejs/src/directives/x-on.js
$99b18dd98d1424fc$var$mapAttributes($99b18dd98d1424fc$var$startingWith("@", $99b18dd98d1424fc$var$into($99b18dd98d1424fc$var$prefix("on:"))));
$99b18dd98d1424fc$var$directive("on", $99b18dd98d1424fc$var$skipDuringClone((el, { value: value, modifiers: modifiers, expression: expression }, { cleanup: cleanup2 })=>{
    let evaluate2 = expression ? $99b18dd98d1424fc$var$evaluateLater(el, expression) : ()=>{};
    if (el.tagName.toLowerCase() === "template") {
        if (!el._x_forwardEvents) el._x_forwardEvents = [];
        if (!el._x_forwardEvents.includes(value)) el._x_forwardEvents.push(value);
    }
    let removeListener = $99b18dd98d1424fc$var$on(el, value, modifiers, (e)=>{
        evaluate2(()=>{}, {
            scope: {
                "$event": e
            },
            params: [
                e
            ]
        });
    });
    cleanup2(()=>removeListener());
}));
// packages/alpinejs/src/directives/index.js
$99b18dd98d1424fc$var$warnMissingPluginDirective("Collapse", "collapse", "collapse");
$99b18dd98d1424fc$var$warnMissingPluginDirective("Intersect", "intersect", "intersect");
$99b18dd98d1424fc$var$warnMissingPluginDirective("Focus", "trap", "focus");
$99b18dd98d1424fc$var$warnMissingPluginDirective("Mask", "mask", "mask");
function $99b18dd98d1424fc$var$warnMissingPluginDirective(name, directiveName, slug) {
    $99b18dd98d1424fc$var$directive(directiveName, (el)=>$99b18dd98d1424fc$var$warn(`You can't use [x-${directiveName}] without first installing the "${name}" plugin here: https://alpinejs.dev/plugins/${slug}`, el));
}
// packages/alpinejs/src/index.js
$99b18dd98d1424fc$var$alpine_default.setEvaluator($99b18dd98d1424fc$var$normalEvaluator);
$99b18dd98d1424fc$var$alpine_default.setReactivityEngine({
    reactive: $99b18dd98d1424fc$var$reactive2,
    effect: $99b18dd98d1424fc$var$effect2,
    release: $99b18dd98d1424fc$var$stop,
    raw: $99b18dd98d1424fc$var$toRaw
});
var $99b18dd98d1424fc$export$b7ee041e4ad2afec = $99b18dd98d1424fc$var$alpine_default;
// packages/alpinejs/builds/module.js
var $99b18dd98d1424fc$export$2e2bcd8739ae039 = $99b18dd98d1424fc$export$b7ee041e4ad2afec;


var $12d8d2de8443a8fd$exports = {};
$12d8d2de8443a8fd$exports = JSON.parse('{"header":"Heiliges ARAM-am-Abend Gesetzbuch (HAramAAGB)","paragraphs":[{"header":"Anwendbarkeit","sections":["Dieses Gesetz findet abweichend nachfolgender Bestimmungen Anwendung im Spielmodus All-Random-All-Mid (ARAM).","Die Karte des Spielmodus ist Howling Abyss.","In F\xe4llen eines ARAM-Clash\'s sind die nachfolgenden Regeln in der Hinsicht entsprechend anwendbar, sodass der Sieg die oberste Priorit\xe4t ist.","Ein ARAM ist wichtiger, als ein Ranked."]},{"header":"Anzahl der ARAM","sections":["Generell sind drei ARAM zu spielen. Die zu verwendende Bezeichnung ist: ARAM-am-Abend (AAA).","Liegen triftige Gr\xfcnde vor, die die Durchf\xfchrung des AAA nach Abs. 1 verhindern, kann die Anzahl der ARAM auf eins reduziert werden. Zwei ARAM sind grunds\xe4tzlich verboten.","Die f\xfcr Abs. 1 und 2 zu verwendende Anzahl der ARAM ist zum Modulus 3 zu berechnen.","Gespielte ARAM im Sinne des Abs. 1 sind nur solche, die nicht geremaked wurden.","Dieser Vorschrift steht ein Tageswechsel nicht entgegen.","Wird eine unzul\xe4ssige Anzahl an ARAM gespielt ist \xa7 9 anzuwenden. Die Ausnahmen nach \xa7 3 sind zu beachten."]},{"header":"Ausnahmen","sections":["In verzweifelten F\xe4llen werden in \xdcbereinkunft beteiligter Personen ARAM gespielt und durch eine gemeinsame Bekundung durch ein \u201EARGHHHHHHHHH\u201C, welches klar und deutlich zu erkennen sein muss, kenntlich gemacht, bis ein Sieg errungen werden kann. \xa7 2 Abs. 3 ist nicht anzuwenden.","Im Falle des \xa7 2 Abs. 2 Satz 2 dieser Vorschrift ist, die Bereitschaft nur zwei ARAM spielen zu wollen offenkundig zu machen. Diese Vorschrift ist nur in Ausnahmef\xe4llen anzuwenden. Dies ist insbesondere dann gegeben, wenn den Teilnehmern wenig Zeit aufgrund morgendlicher Verpflichtungen zur Verf\xfcgung steht. Sanktionen sind nicht zu verh\xe4ngen. \xa7 2 Abs. 3 ist entsprechend anzuwenden."]},{"header":"Summoner Spells","sections":["Die AAA-Summoner-Spells sind Flash und Snowball.","Von dieser Regel darf nur durch ein Mehrheitsvotum oder durch Pick des Champions \u201EYuumi\u201C abgewichen werden. Satz 2 ist f\xfcr \xe4hnliche Champions entsprechend anzuwenden.","Nichtbefolgung zieht das Schreiben von \u201Creport [Spieler] for lack of snowball\u201D durch verbleibende Gruppenmitglieder im f\xfcr das gegnerische Team sichtbaren Kommunikationskanal nach sich. \xa7 9 ist anzuwenden","In Ausnahmef\xe4llen kann anstelle von Flash ein vergleichbarer Summoner-Spell gew\xe4hlt werden. Dies gilt nur in F\xe4llen, bei denen die Effizienz des Picks durch den anderen Summoner-Spell erh\xf6ht werden kann."]},{"header":"Finish","sections":["M\xf6glichkeiten zum siegreichen Beenden des ARAM d\xfcrfen nur in Anspruch genommen werden, wenn ansonsten die Gefahr der eigenen Niederlage nach \xfcbereinstimmender Einsch\xe4tzung der beteiligten Personen unabwendbar erscheint.","Genannte Bedingung muss nicht erf\xfcllt sein, wenn die eigenen Nexust\xfcrme bereits zerst\xf6rt wurden. (Nomos-Regel).","Aus Zeitmangel darf von Abs. (1) abgewichen werden.","\xa7 5 findet keine Anwendung in F\xe4llen des \xa7 1 Abs. 3."]},{"header":"ARAM-Gott","sections":["Den Weisungen einer Person mit mindestens 2000 ARAM-Spielen (ARAM-Gott) ist stets Folge zu leisten.","Der ARAM-Gott ist befugt eine Reduzierung oder Erh\xf6hung der ARAM gem\xe4\xdf \xa7 3 anzuordnen.","Bei Uneinigkeiten unter ARAM-G\xf6ttern, hat der ARAM-Gott recht, der mehr ARAM gespielt hat.","Bei Gleichstand des Abs. 3 entscheidet der Spieler mit der h\xf6heren ARAM-Winrate. Ist durch Rundung auf die zweite Nachkommastelle der Gleichstand nicht entschieden, so entscheidet ein M\xfcnzwurf."]},{"header":"Kerngedanke","sections":["Der Kerngedanke des AAA lautet: \u201EEinfach Rein!\u201C.","Getroffene Schneeb\xe4lle m\xfcssen grunds\xe4tzlich reaktiviert werden, wenn die M\xf6glichkeit des gegnerischen Todes besteht (captain-Gesetz).","In F\xe4llen des \xa7 1 Abs. 3 ist eine Abw\xe4gung des Abs. 2 zwingend durchzuf\xfchren. Von dieser Regelung darf abgewichen werden, wenn Bedingungen gem\xe4\xdf \xa7 4 Abs. 2 zutreffen."]},{"header":"Weitere Bestimmungen","sections":["Ein Reroll ist zu benutzen, wenn zwei Rerolls vorhanden sind.","Dem ARAM darf weder im Vorhinein gedodged, noch darf es w\xe4hrend des Spiels surrendert werden. Dies gilt nicht, wenn triftige Gr\xfcnde angef\xfchrt werden k\xf6nnen.","Ein Tod, der nach bestem Wissen und Gewissen als Execute gewertet werden wird, ist zul\xe4ssig. Dies gilt nicht, wenn die begr\xfcndete Annahme besteht, dass der Tod unmittelbar zur Niederlage des ARAM f\xfchren wird, insbesondere in F\xe4llen des \xa7 1 Abs. 3. Der ARAM-Gott ist befugt vorr\xfcbergehend die Zul\xe4ssigkeit der Executes zu unterbinden.","Die Regeln dieses Gesetzes finden auf \xe4hnliche Spielmodi entsprechende Anwendung.","Flash kann genutzt werden, um einen Heal zu erlangen. Dies gilt nicht in F\xe4llen des \xa7 1 Abs. 3.","Eine Liste, welche die l\xe4ngsten ARAM auflistet, wird erstellt. Dabei sind Uhrzeit des Beginns und des Endes entscheidend. Die Zeit wird mittels des Clients berechnet.","Regelm\xe4\xdfige Teilnehmer des AAA sollen in ihrem League-Status die Anzahl ihrer ARAM angeben. Dies gilt nicht bei besonderen Anl\xe4ssen."]},{"header":"Sanktionen","sections":["Nichtbefolgung einer Regel wird mit zehn Liegest\xfctzen geahndet.","\xdcber die Durchf\xfchrung der Strafe wacht der in \xa7 10 Abs. 2 genannte Personenkreis.","In Ausnahef\xe4llen kann die Strafe durch Mehrheitsbeschluss erlassen werden."]},{"header":"Inkrafttreten, Bindung","sections":["Dieses Gesetz tritt durch seine Verk\xfcndung im Teamspeak in Kraft. Es ist von CodeHat auf entsprechender Webseite zug\xe4nglich zu machen.","S\xe4mtliche nachfolgenden Personen haben das Gesetz ratifiziert (Jxxxxx, CxxxHxx, cxxxxxx0000, Ixxxxxxxx, Nxxxx00, Jxxxxx, Kxxxxx Bxxx).","Die in Absatz 2 genannten Personen haben diesem Gesetz stets Folge zu leisten.","Treten zu den in Abs. 2 genannten Personen eine weitere Person in einem Spiel hinzu, so wird diese Person auf dieses Gesetz hingewiesen."]}],"footer":"Gezeichnet\\nDer Elohell-Pr\xe4sident\\nCaptain Teemo","version":"20/07/2023"}');


var $6270b59cd2665aed$export$2e2bcd8739ae039 = ()=>({
        rules: (0, (/*@__PURE__*/$parcel$interopDefault($12d8d2de8443a8fd$exports)))
    });


window.Alpine = (0, $99b18dd98d1424fc$export$2e2bcd8739ae039);
(0, $99b18dd98d1424fc$export$2e2bcd8739ae039).data('rules', (0, $6270b59cd2665aed$export$2e2bcd8739ae039));
(0, $99b18dd98d1424fc$export$2e2bcd8739ae039).start();

})();
//# sourceMappingURL=index.ad89adb4.js.map
